(window.theme = window.theme || {}),
  (window.lazySizesConfig = window.lazySizesConfig || {}),
  (lazySizesConfig.expFactor = 4),
  (function (e) {
    e = jQuery = e;
    (theme.utils = {
      defaultTo: function (e, t) {
        return null == e || e != e ? t : e;
      },
    }),
      (theme.a11y = {
        trapFocus: function (t) {
          var i = { focusin: t.namespace ? "focusin." + t.namespace : "focusin", focusout: t.namespace ? "focusout." + t.namespace : "focusout", keydown: t.namespace ? "keydown." + t.namespace : "keydown.handleFocus" },
            n = t.$container.find(e('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])').filter(":visible")),
            o = n[0],
            a = n[n.length - 1];
          t.$elementToFocus || (t.$elementToFocus = t.$container),
            t.$container.attr("tabindex", "-1"),
            t.$elementToFocus.focus(),
            e(document).off("focusin"),
            e(document).on(i.focusout, function () {
              e(document).off(i.keydown);
            }),
            e(document).on(i.focusin, function (t) {
              (t.target === a || t.target === o) &&
                e(document).on(i.keydown, function (e) {
                  !(function (e) {
                    9 === e.keyCode && (e.target !== a || e.shiftKey || (e.preventDefault(), o.focus()), e.target === o && e.shiftKey && (e.preventDefault(), a.focus()));
                  })(e);
                });
            });
        },
        removeTrapFocus: function (t) {
          var i = t.namespace ? "focusin." + t.namespace : "focusin";
          t.$container && t.$container.length && t.$container.removeAttr("tabindex"), e(document).off(i);
        },
        lockMobileScrolling: function (t, i) {
          if (i) var n = i;
          else n = e(document.documentElement).add("body");
          n.on("touchmove" + t, function () {
            return !1;
          });
        },
        unlockMobileScrolling: function (t, i) {
          if (i) var n = i;
          else n = e(document.documentElement).add("body");
          n.off(t);
        },
      }),
      (theme.Sections = function () {
        (this.constructors = {}),
          (this.instances = []),
          e(document)
            .on("shopify:section:load", this._onSectionLoad.bind(this))
            .on("shopify:section:unload", this._onSectionUnload.bind(this))
            .on("shopify:section:select", this._onSelect.bind(this))
            .on("shopify:section:deselect", this._onDeselect.bind(this))
            .on("shopify:block:select", this._onBlockSelect.bind(this))
            .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
      }),
      (theme.Sections.prototype = e.extend({}, theme.Sections.prototype, {
        createInstance: function (t, i, n) {
          var o = e(t),
            a = o.attr("data-section-id"),
            s = o.attr("data-section-type");
          if (void 0 !== (i = i || this.constructors[s])) {
            if (n) if (this._findInstance(a)) return;
            var r = e.extend(new i(t), { id: a, type: s, container: t });
            this.instances.push(r);
          }
        },
        _onSectionLoad: function (t, i, n) {
          AOS && AOS.refreshHard();
          var o = i || e("[data-section-id]", t.target)[0];
          if (o) {
            this.createInstance(o);
            var a = i ? n : this._findInstance(t.detail.sectionId);
            i || this._loadSubSections(), a && "function" == typeof a.onLoad && a.onLoad(t);
          }
        },
        _loadSubSections: function () {
          AOS && AOS.refreshHard(),
            e("[data-subsection]").each(
              function (t, i) {
                this._onSectionLoad(null, i, e(i).data("section-id"));
              }.bind(this)
            );
        },
        _onSectionUnload: function (e) {
          var t = this._removeInstance(e.detail.sectionId);
          t && "function" == typeof t.onUnload && t.onUnload(e);
        },
        _onSelect: function (e) {
          var t = this._findInstance(e.detail.sectionId);
          t && "function" == typeof t.onSelect && t.onSelect(e);
        },
        _onDeselect: function (e) {
          var t = this._findInstance(e.detail.sectionId);
          t && "function" == typeof t.onDeselect && t.onDeselect(e);
        },
        _onBlockSelect: function (e) {
          var t = this._findInstance(e.detail.sectionId);
          t && "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
        },
        _onBlockDeselect: function (e) {
          var t = this._findInstance(e.detail.sectionId);
          t && "function" == typeof t.onBlockDeselect && t.onBlockDeselect(e);
        },
        _findInstance: function (e) {
          for (var t = 0; t < this.instances.length; t++) if (this.instances[t].id === e) return this.instances[t];
        },
        _removeInstance: function (e) {
          for (var t, i = this.instances.length; i--; )
            if (this.instances[i].id === e) {
              (t = this.instances[i]), this.instances.splice(i, 1);
              break;
            }
          return t;
        },
        register: function (t, i, n) {
          this.constructors[t] = i;
          var o = e("[data-section-type=" + t + "]");
          n && (o = e("[data-section-type=" + t + "]", n)),
            o.each(
              function (e, t) {
                this.createInstance(t, i, n);
              }.bind(this)
            );
        },
      })),
      (theme.Currency = (function () {
        var e = "${{amount}}";
        return {
          formatMoney: function (t, i) {
            function n(e, t, i, n) {
              if (((t = theme.utils.defaultTo(t, 2)), (i = theme.utils.defaultTo(i, ",")), (n = theme.utils.defaultTo(n, ".")), isNaN(e) || null == e)) return 0;
              var o = (e = (e / 100).toFixed(t)).split(".");
              return o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (o[1] ? n + o[1] : "");
            }
            i || (i = theme.settings.moneyFormat), "string" == typeof t && (t = t.replace(".", ""));
            var o = "",
              a = /\{\{\s*(\w+)\s*\}\}/,
              s = i || e;
            switch (s.match(a)[1]) {
              case "amount":
                o = n(t, 2);
                break;
              case "amount_no_decimals":
                o = n(t, 0);
                break;
              case "amount_with_comma_separator":
                o = n(t, 2, ".", ",");
                break;
              case "amount_no_decimals_with_comma_separator":
                o = n(t, 0, ".", ",");
                break;
              case "amount_no_decimals_with_space_separator":
                o = n(t, 0, " ");
            }
            return s.replace(a, o);
          },
          getBaseUnit: function (e) {
            return e && e.unit_price_measurement && e.unit_price_measurement.reference_value
              ? 1 === e.unit_price_measurement.reference_value
                ? e.unit_price_measurement.reference_unit
                : e.unit_price_measurement.reference_value + e.unit_price_measurement.reference_unit
              : void 0;
          },
        };
      })()),
      (theme.Images = (function () {
        return {
          imageSize: function (e) {
            if (!e) return "620x";
            var t = e.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
            return null !== t ? t[1] : null;
          },
          getSizedImageUrl: function (e, t) {
            if (!e) return e;
            if (null == t) return e;
            if ("master" === t) return this.removeProtocol(e);
            var i = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
            if (null != i) {
              var n = e.split(i[0]),
                o = i[0];
              return this.removeProtocol(n[0] + "_" + t + o);
            }
            return null;
          },
          removeProtocol: function (e) {
            return e.replace(/http(s)?:/, "");
          },
        };
      })()),
      (theme.Variants = (function () {
        function t(t) {
          (this.$container = t.$container),
            (this.variants = t.variants),
            (this.singleOptionSelector = t.singleOptionSelector),
            (this.originalSelectorId = t.originalSelectorId),
            (this.enableHistoryState = t.enableHistoryState),
            (this.currentVariant = this._getVariantFromOptions()),
            e(this.singleOptionSelector, this.$container).on("change", this._onSelectChange.bind(this));
        }
        return (
          (t.prototype = e.extend({}, t.prototype, {
            _getCurrentOptions: function () {
              var t = e.map(e(this.singleOptionSelector, this.$container), function (t) {
                var i = e(t),
                  n = i.attr("type"),
                  o = {};
                return "radio" === n || "checkbox" === n ? !!i[0].checked && ((o.value = i.val()), (o.index = i.data("index")), o) : ((o.value = i.val()), (o.index = i.data("index")), o);
              });
              return this._compact(t);
            },
            _getVariantFromOptions: function () {
              var e = this._getCurrentOptions(),
                t = this.variants,
                i = !1;
              return (
                t.forEach(function (t) {
                  var n = !0;
                  t.options,
                    e.forEach(function (e) {
                      n && (n = t[e.index] === e.value);
                    }),
                    n && (i = t);
                }),
                i || null
              );
            },
            _onSelectChange: function () {
              var e = this._getVariantFromOptions();
              this.$container.trigger({ type: "variantChange", variant: e }),
                e && (this._updateMasterSelect(e), this._updateImages(e), this._updatePrice(e), this._updateUnitPrice(e), this._updateSKU(e), (this.currentVariant = e), this.enableHistoryState && this._updateHistoryState(e));
            },
            _updateImages: function (e) {
              var t = e.featured_image || {},
                i = this.currentVariant.featured_image || {};
              e.featured_image && t.src !== i.src && this.$container.trigger({ type: "variantImageChange", variant: e });
            },
            _updatePrice: function (e) {
              (e.price !== this.currentVariant.price || e.compare_at_price !== this.currentVariant.compare_at_price) && this.$container.trigger({ type: "variantPriceChange", variant: e });
            },
            _updateUnitPrice: function (e) {
              e.unit_price !== this.currentVariant.unit_price && this.$container.trigger({ type: "variantUnitPriceChange", variant: e });
            },
            _updateSKU: function (e) {
              e.sku !== this.currentVariant.sku && this.$container.trigger({ type: "variantSKUChange", variant: e });
            },
            _updateHistoryState: function (e) {
              if (history.replaceState && e) {
                var t = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + e.id;
                window.history.replaceState({ path: t }, "", t);
              }
            },
            _updateMasterSelect: function (t) {
              e(this.originalSelectorId, this.$container).val(t.id);
            },
            _compact: function (e) {
              for (var t = -1, i = null == e ? 0 : e.length, n = 0, o = []; ++t < i; ) {
                var a = e[t];
                a && (o[n++] = a);
              }
              return o;
            },
          })),
          t
        );
      })()),
      (theme.rte = {
        init: function () {
          theme.rte.wrapTable(), theme.rte.wrapVideo(), theme.rte.imageLinks();
        },
        wrapTable: function () {
          e(".rte table").wrap('<div class="table-wrapper"></div>');
        },
        wrapVideo: function () {
          var t = e('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]'),
            i = t.add("iframe#admin_bar_iframe");
          t.each(function () {
            e(this).parents(".video-wrapper").length || e(this).wrap('<div class="video-wrapper"></div>');
          }),
            i.each(function () {
              this.src = this.src;
            });
        },
        imageLinks: function () {
          e(".rte a img").parent().addClass("rte__image");
        },
      }),
      (theme.LibraryLoader = (function () {
        var e = { link: "link", script: "script" },
          t = { requested: "requested", loaded: "loaded" },
          i = "https://cdn.shopify.com/shopifycloud/",
          n = {
            youtubeSdk: { tagId: "youtube-sdk", src: "https://www.youtube.com/iframe_api", type: e.script },
            shopifyXr: { tagId: "shopify-model-viewer-xr", src: i + "shopify-xr-js/assets/v1.0/shopify-xr.en.js", type: e.script },
            modelViewerUi: { tagId: "shopify-model-viewer-ui", src: i + "model-viewer-ui/assets/v1.0/model-viewer-ui.en.js", type: e.script },
            modelViewerUiStyles: { tagId: "shopify-model-viewer-ui-styles", src: i + "model-viewer-ui/assets/v1.0/model-viewer-ui.css", type: e.link },
          };
        return {
          load: function (i, o) {
            var a = n[i];
            if (a && a.status !== t.requested) {
              if (((o = o || function () {}), a.status === t.loaded)) return void o();
              var s;
              switch (((a.status = t.requested), a.type)) {
                case e.script:
                  s = (function (e, i) {
                    var n = document.createElement("script");
                    return (
                      (n.src = e.src),
                      n.addEventListener("load", function () {
                        (e.status = t.loaded), i();
                      }),
                      n
                    );
                  })(a, o);
                  break;
                case e.link:
                  s = (function (e, i) {
                    var n = document.createElement("link");
                    return (
                      (n.href = e.src),
                      (n.rel = "stylesheet"),
                      (n.type = "text/css"),
                      n.addEventListener("load", function () {
                        (e.status = t.loaded), i();
                      }),
                      n
                    );
                  })(a, o);
              }
              (s.id = a.tagId), (a.element = s);
              var r = document.getElementsByTagName(a.type)[0];
              r.parentNode.insertBefore(s, r);
            }
          },
        };
      })()),
      (theme.Modals = (function () {
        function t(t, i, n) {
          var o = {
            close: ".js-modal-close",
            open: ".js-modal-open-" + i,
            openClass: "modal--is-active",
            closingClass: "modal--is-closing",
            bodyOpenClass: "modal-open",
            bodyOpenSolidClass: "modal-open--solid",
            bodyClosingClass: "modal-closing",
            closeOffContentClick: !0,
          };
          return (
            (this.id = t),
            (this.$modal = e("#" + t)),
            !!this.$modal.length &&
              ((this.nodes = { $parent: e("html").add("body"), $modalContent: this.$modal.find(".modal__inner") }),
              (this.config = e.extend(o, n)),
              (this.modalIsOpen = !1),
              (this.$focusOnOpen = this.config.focusOnOpen ? e(this.config.focusOnOpen) : this.$modal),
              (this.isSolid = this.config.solid),
              void this.init())
          );
        }
        return (
          (t.prototype.init = function () {
            e(this.config.open).attr("aria-expanded", "false"),
              e(this.config.open).on("click", this.open.bind(this)),
              this.$modal.find(this.config.close).on("click", this.close.bind(this)),
              e("body").on(
                "drawerOpen",
                function () {
                  this.close();
                }.bind(this)
              );
          }),
          (t.prototype.open = function (t) {
            var i = !1;
            this.modalIsOpen ||
              (t ? t.preventDefault() : (i = !0),
              t && t.stopPropagation && (t.stopPropagation(), (this.$activeSource = e(t.currentTarget).attr("aria-expanded", "true"))),
              this.modalIsOpen && !i && this.close(),
              this.$modal.prepareTransition().addClass(this.config.openClass),
              this.nodes.$parent.addClass(this.config.bodyOpenClass),
              this.isSolid && this.nodes.$parent.addClass(this.config.bodyOpenSolidClass),
              (this.modalIsOpen = !0),
              theme.a11y.trapFocus({ $container: this.$modal, $elementToFocus: this.$focusOnOpen, namespace: "modal_focus" }),
              e("body")
                .trigger("productModalOpen")
                .trigger("modalOpen." + this.id),
              this.bindEvents());
          }),
          (t.prototype.close = function () {
            this.modalIsOpen &&
              (e(document.activeElement).trigger("blur"),
              this.$modal.prepareTransition().removeClass(this.config.openClass).addClass(this.config.closingClass),
              this.nodes.$parent.removeClass(this.config.bodyOpenClass),
              this.nodes.$parent.addClass(this.config.bodyClosingClass),
              window.setTimeout(
                function () {
                  this.nodes.$parent.removeClass(this.config.bodyClosingClass),
                    this.$modal.removeClass(this.config.closingClass),
                    this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "false").focus();
                }.bind(this),
                500
              ),
              this.isSolid && this.nodes.$parent.removeClass(this.config.bodyOpenSolidClass),
              (this.modalIsOpen = !1),
              theme.a11y.removeTrapFocus({ $container: this.$modal, namespace: "modal_focus" }),
              e("body").trigger("modalClose." + this.id),
              this.unbindEvents());
          }),
          (t.prototype.bindEvents = function () {
            this.nodes.$parent.on(
              "keyup.modal",
              function (e) {
                27 === e.keyCode && this.close();
              }.bind(this)
            ),
              this.config.closeOffContentClick &&
                (this.$modal.on("click.modal", this.close.bind(this)),
                this.nodes.$modalContent.on("click.modal", function (e) {
                  e.stopImmediatePropagation();
                }));
          }),
          (t.prototype.unbindEvents = function () {
            this.nodes.$parent.off(".modal"), this.config.closeOffContentClick && (this.$modal.off(".modal"), this.nodes.$modalContent.off(".modal"));
          }),
          t
        );
      })()),
      (theme.Drawers = (function () {
        function t(t, i) {
          return (
            (this.config = { id: t, close: ".js-drawer-close", open: ".js-drawer-open-" + i, openClass: "js-drawer-open", closingClass: "js-drawer-closing", activeDrawer: "drawer--is-open", namespace: ".drawer-" + i }),
            (this.$nodes = { parent: e(document.documentElement).add("body"), page: e("#MainContent") }),
            (this.$drawer = e("#" + t)),
            !!this.$drawer.length && ((this.isOpen = !1), void this.init())
          );
        }
        return (
          (t.prototype = e.extend({}, t.prototype, {
            init: function () {
              var t = e(this.config.open);
              t.attr("aria-expanded", "false"),
                t.on("click", this.open.bind(this)),
                this.$drawer.find(this.config.close).on("click", this.close.bind(this)),
                e("body").on(
                  "productModalOpen",
                  function () {
                    console.log("Close Modal");
                  }.bind(this)
                );
            },
            open: function (t, i) {
              if ((t && t.preventDefault(), !this.isOpen)) {
                if (t && t.stopPropagation) t.stopPropagation(), (this.$activeSource = e(t.currentTarget).attr("aria-expanded", "true"));
                else if (i) {
                  var n = e(i);
                  this.$activeSource = n.attr("aria-expanded", "true");
                }
                this.$drawer.prepareTransition().addClass(this.config.activeDrawer),
                  this.$nodes.parent.addClass(this.config.openClass),
                  (this.isOpen = !0),
                  theme.a11y.trapFocus({ $container: this.$drawer, namespace: "drawer_focus" }),
                  e("body")
                    .trigger("drawerOpen")
                    .trigger("drawerOpen." + this.config.id),
                  this.bindEvents();
              }
            },
            close: function () {
              this.isOpen &&
                (e(document.activeElement).trigger("blur"),
                this.$drawer.prepareTransition().removeClass(this.config.activeDrawer),
                this.$nodes.parent.removeClass(this.config.openClass),
                this.$nodes.parent.addClass(this.config.closingClass),
                window.setTimeout(
                  function () {
                    this.$nodes.parent.removeClass(this.config.closingClass), this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "false").focus();
                  }.bind(this),
                  500
                ),
                (this.isOpen = !1),
                theme.a11y.removeTrapFocus({ $container: this.$drawer, namespace: "drawer_focus" }),
                this.unbindEvents());
            },
            bindEvents: function () {
              theme.a11y.lockMobileScrolling(this.config.namespace, this.$nodes.page),
                this.$nodes.page.on(
                  "click" + this.config.namespace,
                  function () {
                    return this.close(), !1;
                  }.bind(this)
                ),
                this.$nodes.parent.on(
                  "keyup" + this.config.namespace,
                  function (e) {
                    27 === e.keyCode && this.close();
                  }.bind(this)
                );
            },
            unbindEvents: function () {
              theme.a11y.unlockMobileScrolling(this.config.namespace, this.$nodes.page), this.$nodes.parent.off(this.config.namespace), this.$nodes.page.off(this.config.namespace);
            },
          })),
          t
        );
      })()),
      (theme.cart = {
        getCart: function () {
          return e.getJSON(theme.routes.cart);
        },
        changeItem: function (e, t) {
          return this._updateCart({ type: "POST", url: theme.routes.cartChange, data: "quantity=" + t + "&id=" + e, dataType: "json" });
        },
        addItemFromForm: function (e) {
          return this._updateCart({ type: "POST", url: theme.routes.cartAdd, data: e, dataType: "json" });
        },
        _updateCart: function (t) {
          return e.ajax(t).then(
            function (e) {
              return e;
            }.bind(this)
          );
        },
        updateNote: function (t) {
          var i = { type: "POST", url: "/cart/update.js", data: "note=" + theme.cart.attributeToString(t), dataType: "json", success: function (e) {}, error: function (e, t) {} };
          e.ajax(i);
        },
        attributeToString: function (t) {
          return "string" != typeof t && "undefined" === (t += "") && (t = ""), e.trim(t);
        },
      }),
      e(function () {
        e("body").on("click", ".cart__checkout", function () {
          e(this).addClass("btn--loading");
        }),
          e("body").on("change", 'textarea[name="note"]', function () {
            var t = e(this).val();
            theme.cart.updateNote(t);
          }),
          e("body").on("click", ".cart__checkout--ajax", function (t) {
            return e("#CartAgree").is(":checked") ? void 0 : (alert(theme.strings.cartTermsConfirmation), e(this).removeClass("btn--loading"), !1);
          }),
          e("body").on("click", ".cart__checkout--page", function (t) {
            return e("#CartPageAgree").is(":checked") ? void 0 : (alert(theme.strings.cartTermsConfirmation), e(this).removeClass("btn--loading"), !1);
          });
      }),
      (theme.QtySelector = (function () {
        function t(t, n) {
          (this.$wrapper = t), (this.$input = t.find(i.input)), (this.$plus = t.find(i.plus)), (this.$minus = t.find(i.minus)), (this.minValue = this.$input.attr("min") || 1);
          var o = { namespace: null, key: this.$input.data("id") };
          (this.options = e.extend(o, n)), this.initEventListeners();
        }
        var i = { input: ".js-qty__num", plus: ".js-qty__adjust--plus", minus: ".js-qty__adjust--minus" };
        return (
          (t.prototype = e.extend({}, t.prototype, {
            initEventListeners: function () {
              this.$plus.on(
                "click",
                function () {
                  var e = this.validateQty(this.$input.val());
                  this.addQty(e);
                }.bind(this)
              ),
                this.$minus.on(
                  "click",
                  function () {
                    var e = this.validateQty(this.$input.val());
                    this.subtractQty(e);
                  }.bind(this)
                ),
                this.$input.on(
                  "change",
                  function () {
                    var e = this.validateQty(this.$input.val());
                    this.changeQty(e);
                  }.bind(this)
                );
            },
            addQty: function (e) {
              var t = e + 1;
              this.changeQty(t);
            },
            subtractQty: function (e) {
              var t = e - 1;
              t <= this.minValue && (t = this.minValue), this.changeQty(t);
            },
            changeQty: function (t) {
              this.$input.val(t), e("body").trigger("qty" + this.options.namespace, [this.options.key, t]);
            },
            validateQty: function (e) {
              return (parseFloat(e) != parseInt(e) || isNaN(e)) && (e = 1), parseInt(e);
            },
          })),
          t
        );
      })()),
      (theme.CartDrawer = (function () {
        function t() {
          (this.status = { loaded: !1, loading: !1 }), (this.drawer = new theme.Drawers("CartDrawer", "cart"));
          var t = e(n.template).html();
          (this.template = Handlebars.compile(t)), theme.cart.getCart().then(this.buildCart.bind(this)), this.initEventListeners();
        }
        var i = ".ajaxcart",
          n = { drawer: "#CartDrawer", container: "#CartContainer", template: "#CartTemplate", cartBubble: ".cart-link__bubble" };
        return (
          (t.prototype = e.extend({}, t.prototype, {
            initEventListeners: function () {
              e("body").on("updateCart" + i, this.initQtySelectors.bind(this)),
                e("body").on("updateCart" + i, this.updateCartNotification.bind(this)),
                e("body").on(
                  "added.ajaxProduct",
                  function (e, t) {
                    theme.cart.getCart().then(
                      function (e) {
                        this.buildCart(e, !0, t);
                      }.bind(this)
                    );
                  }.bind(this)
                );
            },
            buildCart: function (t, o, a) {
              const totalSums = [];
              const s = t.items.length && t.items,
                r = $(".product-upsell").data("id"),
                d = $(".expansion-popup").data("id");
              if ((r && s.length && s.find((e) => e.id === +r) ? $(".product-upsell").slideUp() : $(".product-upsell").slideDown(), d)) {
                s.length && s.find((e) => e.id === +d)
                  ? $('.product-section .product-single__form  .add-to-cart:not(".upsell-add-to-cart, .popup-add-to-cart")').attr("type", "submit") &&
                    $('.product-section .product-single__form  button:not(".upsell-add-to-cart, .popup-add-to-cart")').removeClass("js-trigger-open")
                  : $('.product-section .product-single__form  .add-to-cart:not(".upsell-add-to-cart, .popup-add-to-cart")').attr("type", "button") &&
                    $('.product-section .product-single__form  button:not(".upsell-add-to-cart, .popup-add-to-cart")').addClass("js-trigger-open");
              }
              if ((this.loading(!0), this.emptyCart(), 0 === t.item_count)) e(n.container).append('<div class="drawer__scrollable"><p class="appear-animation appear-delay-3">' + theme.strings.cartEmpty + "</p></div>");
              else {
                var c,
                  l = [],
                  h = {},
                  u = 1;
                e.each(t.items, function (t, i) {
                  var n;
                  let origin__price = 0;
                  (n = null !== i.image ? i.image.replace(/(\.[^.]*)$/, "_180x$1") : "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif"),
                    null !== i.properties &&
                      e.each(i.properties, function (e, t) {
                        if (e === "_original_price") {
                          origin__price = parseInt(t);
                          totalSums.push({quantity: i.quantity, price: origin__price});
                        }
                        ("_" !== e.charAt(0) && t) || delete i.properties[e];
                      });
                  var o = 0;
                  if (0 !== i.line_level_discount_allocations.length)
                    for (var a in i.line_level_discount_allocations) (o = i.line_level_discount_allocations[a].amount), (i.line_level_discount_allocations[a].formattedAmount = theme.Currency.formatMoney(o, theme.settings.moneyFormat));
                  (u += 2),
                    (h = {
                      key: i.key,
                      url: i.url,
                      img: n,
                      animationRow: u,
                      name: i.product_title,
                      variation: i.variant_title,
                      properties: i.properties,
                      itemQty: i.quantity,
                      price: theme.Currency.formatMoney(i.price, theme.settings.moneyFormat),
                      lineItemTotalPrice: theme.Currency.formatMoney(i.price * i.quantity, theme.settings.moneyFormat),
                      unitPrice: theme.Currency.formatMoney(i.unit_price, theme.settings.moneyFormat),
                      unitBase: theme.Currency.getBaseUnit(i),
                      originalPrice: origin__price > 0 ? theme.Currency.formatMoney(origin__price, theme.settings.moneyFormat) : "",
                      totalOriginalPrice: (origin__price * i.quantity) > 0 ? theme.Currency.formatMoney(origin__price * i.quantity, theme.settings.moneyFormat) : "",
                      discountedPrice: theme.Currency.formatMoney(i.price - i.total_discount / i.quantity, theme.settings.moneyFormat),
                      discounts: i.line_level_discount_allocations,
                      discountsApplied: 0 !== i.line_level_discount_allocations.length,
                      vendor: i.vendor,
                    }),
                    l.push(h);
                }),
                  (u += 2);
                //code for the discount fix
                var p = 0;
                if (0 !== t.cart_level_discount_applications.length)
                  for (var m in t.cart_level_discount_applications){
                    (p = t.cart_level_discount_applications[m].total_allocated_amount) ,(t.cart_level_discount_applications[m].formattedAmount = theme.Currency.formatMoney(p, theme.settings.moneyFormat));
                        if (!p){
                            p = t.cart_level_discount_applications[m].discount_application.total_allocated_amount;
                            t.cart_level_discount_applications[m].formattedAmount = theme.Currency.formatMoney(p, theme.settings.moneyFormat);
                            t.cart_level_discount_applications[m].title = t.cart_level_discount_applications[m].discount_application.title;
                        }
                    }
                    let originalTotalPrice = 0;
                    totalSums.forEach(item => {
                      const itemPrice = item.quantity * item.price;
                      originalTotalPrice += itemPrice;
                    });
                (c = {
                  items: l,
                  note: t.note,
                  lastAnimationRow: u,
                  cartDiscounts: t.cart_level_discount_applications,
                  cartDiscountsApplied: 0 !== t.cart_level_discount_applications.length,
                  totalPrice: theme.Currency.formatMoney(t.total_price, theme.settings.moneyFormat),
                  savedMoney: originalTotalPrice > t.total_price ?  theme.Currency.formatMoney(originalTotalPrice - t.total_price, theme.settings.moneyFormat) : '',
                  subtotalCartPrice: originalTotalPrice > t.total_price ? theme.Currency.formatMoney(originalTotalPrice, theme.settings.moneyFormat) : '',
                }),
                //code for the discount fix END
                  e(n.container).append(this.template(c));
              }
              (this.status.loaded = !0), this.loading(!1), e("body").trigger("updateCart" + i, t), window.Shopify && Shopify.StorefrontExpressButtons && Shopify.StorefrontExpressButtons.initialize(), !0 === o && this.drawer.open(!1, a);
            },
            initQtySelectors: function () {
              e(n.container)
                .find(".js-qty__wrapper")
                .each(
                  function (t, i) {
                    new theme.QtySelector(e(i), { namespace: ".cart-drawer" });
                  }.bind(this)
                ),
                e("body").on("qty.cart-drawer", this.updateItem.bind(this));
            },
            updateItem: function (e, t, i) {
              $("#CartContainer").addClass("is-loading"),
                this.status.loading ||
                  (this.loading(!0),
                  theme.cart
                    .changeItem(t, i)
                    .then(
                      function (e) {
                        this.updateSuccess(e);
                      }.bind(this)
                    )
                    .catch(
                      function (e) {
                        this.updateError(e);
                      }.bind(this)
                    )
                    .always(
                      function () {
                        this.loading(!1), $("#CartContainer").removeClass("is-loading");
                      }.bind(this)
                    ));
            },
            loading: function (t) {
              (this.status.loading = t), t ? e(n.container).addClass("is-loading") : e(n.container).removeClass("is-loading");
            },
            emptyCart: function () {
              e(n.container).empty();
            },
            updateSuccess: function (e) {
              this.buildCart(e);
            },
            updateError: function (e) {
              e.responseJSON && e.responseJSON.description;
            },
            updateCartNotification: function (t, i) {
              i.items.length > 0 ? e(n.cartBubble).addClass("cart-link__bubble--visible") : e(n.cartBubble).removeClass("cart-link__bubble--visible");
              let quantity = 0;
              i.items.forEach(item => {
                quantity += item.quantity;
              });
              i.items.length > 0 ? e(n.cartBubble)[0].innerHTML = quantity : e(n.cartBubble)[0].innerHTML = "";
            },
          })),
          t
        );
      })()),
      (theme.AjaxProduct = (function () {
        function t(e) {
          (this.$form = e), (this.$addToCart = this.$form.find(".add-to-cart")), this.$form.length && this.$form.on("submit", this.addItemFromForm.bind(this));
        }
        var i = { loading: !1 };
        return (
          (t.prototype = e.extend({}, t.prototype, {
            addItemFromForm: function (e, t) {
              if ((e.preventDefault(), !i.loading)) {
                this.$addToCart.addClass("btn--loading"), (i.loading = !0);
                var n = this.$form.serialize();
                theme.cart
                  .addItemFromForm(n)
                  .then(
                    function (e) {
                      this.success(e);
                    }.bind(this)
                  )
                  .catch(
                    function (e) {
                      this.error(e);
                    }.bind(this)
                  )
                  .always(
                    function () {
                      (i.loading = !1), this.$addToCart.removeClass("btn--loading");
                    }.bind(this)
                  );
              }
            },
            success: function (t) {
              this.$form.find(".errors").remove(), e("body").trigger("added.ajaxProduct", this.$addToCart);
            },
            error: function (e) {
              this.$form.find(".errors").remove(), e.responseJSON && e.responseJSON.description && this.$form.prepend('<div class="errors text-center">' + e.responseJSON.description + "</div>");
            },
          })),
          t
        );
      })()),
      (theme.collapsibles = (function () {
        function t(e, t, i, o) {
          if ((e.removeClass(n.hide).prepareTransition().css("height", t).toggleClass(n.open, !i), !i && o)) {
            var s = e;
            window.setTimeout(function () {
              s.css("height", "auto"), (a = !1);
            }, 500);
          } else a = !1;
        }
        var i = { trigger: ".collapsible-trigger", module: ".collapsible-content", moduleInner: ".collapsible-content__inner" },
          n = { hide: "hide", open: "is-open", autoHeight: "collapsible--auto-height" },
          o = ".collapsible",
          a = !1;
        return {
          init: function () {
            e(i.trigger).each(function () {
              var t = e(this),
                i = t.hasClass(n.open);
              t.attr("aria-expanded", i);
            }),
              e("body, .modal__inner")
                .off(o)
                .on("click" + o, i.trigger, function () {
                  if (!a) {
                    a = !0;
                    var o = e(this),
                      s = o.hasClass(n.open),
                      r = o.attr("aria-controls"),
                      d = e("#" + r),
                      c = d.find(i.moduleInner).outerHeight(),
                      l = o.hasClass(n.autoHeight);
                    s &&
                      l &&
                      setTimeout(function () {
                        t(d, (c = 0), s, l);
                      }, 0),
                      s && !l && (c = 0),
                      o.attr("aria-expanded", !s).toggleClass(n.open, !s),
                      t(d, c, s, l);
                  }
                });
          },
        };
      })()),
      (theme.headerNav = (function () {
        function t() {
          e(h.searchContainer).addClass("is-active"),
            c.addClass("js-drawer-open js-drawer-open--search"),
            theme.a11y.trapFocus({ $container: e(h.searchContainer), namespace: "header_search", $elementToFocus: e(h.searchContainer).find("input") }),
            theme.config.bpSmall && p.stickyEnabled && p.lastScroll < 300 && window.scrollTo(0, 0),
            theme.a11y.lockMobileScrolling(p.namespace),
            l.on("click" + p.namespace, function () {
              return i(), !1;
            }),
            c.on("keyup" + p.namespace, function (e) {
              27 === e.keyCode && i();
            });
        }
        function i() {
          e(document.activeElement).trigger("blur"),
            c.removeClass("js-drawer-open js-drawer-open--search").off(p.namespace),
            e(h.searchContainer).removeClass("is-active"),
            theme.a11y.removeTrapFocus({ $container: e(h.searchContainer), namespace: "header_search" }),
            theme.a11y.unlockMobileScrolling(p.namespace),
            l.off("click" + p.namespace),
            c.off("keyup" + p.namespace);
        }
        function n() {
          e(h.logo).each(function () {
            var t = e(this),
              i = t.width(),
              n = t.closest(".grid__item").width();
            i > n ? t.css("maxWidth", n) : t.removeAttr("style");
          });
        }
        function o() {
          e(".site-header-sticky").css("height", d.outerHeight(!0));
        }
        function a() {
          var e = s.scrollTop();
          if (e > 250) {
            if (p.stickyActive) return;
            (p.stickyActive = !0),
              d.addClass(p.stickyClass),
              p.wrapperOverlayed && r.removeClass(p.overlayedClass),
              setTimeout(function () {
                d.addClass(p.openTransitionClass);
              }, 100);
          } else {
            if (!p.stickyActive) return;
            (p.stickyActive = !1), d.removeClass(p.openTransitionClass).removeClass(p.stickyClass), p.wrapperOverlayed && r.addClass(p.overlayedClass);
          }
          p.lastScroll = e;
        }
        var s,
          r,
          d,
          c = e(document.documentElement).add("body"),
          l = e("#MainContent"),
          h = {
            wrapper: ".header-wrapper",
            siteHeader: ".site-header",
            searchBtn: ".js-search-header",
            closeSearch: ".js-search-header-close",
            searchContainer: ".site-header__search-container",
            logoContainer: ".site-header__logo",
            logo: ".site-header__logo img",
            navigation: ".site-navigation",
            navContainerWithLogo: ".header-item--logo",
            navItems: ".site-nav__item",
            navLinks: ".site-nav__link",
            navLinksWithDropdown: ".site-nav__link--has-dropdown",
            navDropdownLinks: ".site-nav__dropdown-link--second-level",
          },
          u = { hasDropdownClass: "site-nav--has-dropdown", hasSubDropdownClass: "site-nav__deep-dropdown-trigger", dropdownActive: "is-focused" },
          p = {
            namespace: ".siteNav",
            wrapperOverlayed: !1,
            overlayedClass: "is-light",
            overlayEnabledClass: "header-wrapper--overlay",
            stickyEnabled: !1,
            stickyActive: !1,
            stickyClass: "site-header--stuck",
            openTransitionClass: "site-header--opening",
            lastScroll: 0,
          };
        return {
          init: function () {
            (s = e(window)),
              e(h.navContainerWithLogo),
              e(h.logoContainer),
              e(h.navigation),
              (r = e(h.wrapper)),
              (d = e(h.siteHeader)),
              (p.stickyEnabled = d.data("sticky")),
              p.stickyEnabled &&
                ((p.wrapperOverlayed = r.hasClass(p.overlayedClass)),
                (p.lastScroll = 0),
                d.wrap('<div class="site-header-sticky"></div>'),
                o(),
                s.on("resize" + p.namespace, e.debounce(50, o)),
                s.on("scroll" + p.namespace, e.throttle(15, a)),
                Shopify &&
                  Shopify.designMode &&
                  setTimeout(function () {
                    o();
                  }, 250)),
              (theme.settings.overlayHeader = d.data("overlay")),
              theme.settings.overlayHeader && Shopify.designMode && e("body").hasClass("template-collection") && !e(".collection-hero").length && this.disableOverlayHeader(),
              (function () {
                function t(t) {
                  var i = t.parent();
                  if ((i.hasClass(u.hasDropdownClass) && (i.addClass(u.dropdownActive), (s = !0)), !theme.config.isTouch && !d)) {
                    var o = theme.config.isTouch ? "touchend" : "click";
                    (d = !0),
                      e("body").on(o + p.namespace, function () {
                        n(), e("body").off(p.namespace), (d = !1);
                      });
                  }
                }
                function i(e, t) {
                  var i = e.parent();
                  (i.hasClass(u.hasSubDropdownClass) || t) && (i.addClass(u.dropdownActive), (r = !0));
                }
                function n() {
                  o(), a();
                }
                function o() {
                  e(h.navItems).removeClass(u.dropdownActive);
                }
                function a() {
                  e(h.navDropdownLinks).parent().removeClass(u.dropdownActive);
                }
                var s = !1,
                  r = !1,
                  d = !1;
                theme.config.isTouch &&
                  (e(h.navLinksWithDropdown).on("touchend" + p.namespace, function (i) {
                    var o = e(this),
                      a = o.parent();
                    a.hasClass(u.dropdownActive) ? window.location.replace(o.attr("href")) : (i.preventDefault(), n(), t(o));
                  }),
                  e(h.navDropdownLinks).on("touchend" + p.namespace, function (t) {
                    var n = e(this),
                      o = n.parent();
                    o.hasClass(u.hasSubDropdownClass) ? (o.hasClass(u.dropdownActive) ? window.location.replace(n.attr("href")) : (t.preventDefault(), a(), i(n))) : window.location.replace(n.attr("href"));
                  })),
                  e(h.navLinks).on("focusin mouseover" + p.namespace, function () {
                    s && o(), r && a(), t(e(this));
                  }),
                  e(h.navLinks).on("mouseleave" + p.namespace, function () {
                    n();
                  }),
                  e(h.navDropdownLinks).on("focusin" + p.namespace, function () {
                    a(), i(e(this), !0);
                  });
              })(),
              e(h.searchBtn).on("click" + p.namespace, function (e) {
                e.preventDefault(), t();
              }),
              e(h.closeSearch).on("click" + p.namespace, function () {
                i();
              }),
              s.on("load" + p.namespace, n),
              s.on("resize" + p.namespace, e.debounce(150, n));
          },
          disableOverlayHeader: function () {
            e(h.wrapper).removeClass(p.overlayEnabledClass).removeClass(p.overlayedClass), (p.wrapperOverlayed = !1);
          },
          unload: function () {
            e(window).off(p.namespace), e(h.searchBtn).off(p.namespace), e(h.closeSearch).off(p.namespace), c.off(p.namespace), e(h.navLinks).off(p.namespace), e(h.navDropdownLinks).off(p.namespace);
          },
        };
      })()),
      (theme.articleImages = (function () {
        function t() {
          i.$rteImages.find("img").each(function () {
            var t = e(this),
              n = t.attr("style");
            (n && "float: none;" != n) || (t.width() < i.$rteImages.width() && t.addClass("rte__no-indent"));
          });
        }
        var i = {};
        return {
          init: function () {
            (i.$rteImages = e(".rte--indented-images")), i.$rteImages.length && e(window).on("load", t);
          },
        };
      })()),
      (theme.Slideshow = (function () {
        function t(t, n) {
          (this.$slideshow = e(t)),
            (this.$wrapper = this.$slideshow.closest("." + i.wrapper)),
            (this.$pause = this.$wrapper.find("." + i.pauseButton)),
            (this.settings = {
              accessibility: !0,
              arrows: !!n.arrows,
              dots: !!n.dots,
              fade: !!n.fade,
              speed: n.speed ? n.speed : 500,
              draggable: !0,
              touchThreshold: 5,
              pauseOnHover: !1,
              autoplay: this.$slideshow.data("autoplay"),
              autoplaySpeed: this.$slideshow.data("speed"),
            }),
            this.$slideshow.on("init", this.init.bind(this)),
            this.settings.fade && (this.$slideshow.on("beforeChange", this.beforeSlideChange.bind(this)), this.$slideshow.on("afterChange", this.afterSlideChange.bind(this))),
            this.$slideshow.slick(this.settings),
            this.$pause.on("click", this._togglePause.bind(this));
        }
        this.$slideshow = null;
        var i = {
          next: "is-next",
          init: "is-init",
          animateOut: "animate-out",
          wrapper: "slideshow-wrapper",
          slideshow: "slideshow",
          allSlides: "slick-slide",
          currentSlide: "slick-current",
          pauseButton: "slideshow__pause",
          isPaused: "is-paused",
        };
        return (
          (t.prototype = e.extend({}, t.prototype, {
            init: function (e, t) {
              (this.$slideshowList = t.$list), (this.$slickDots = t.$dots), (this.$allSlides = t.$slides), (this.slideCount = t.slideCount), this.$slideshow.addClass(i.init), this._a11y(), this._clonedLazyloading();
            },
            beforeSlideChange: function (e, t, n, o) {
              t.$slider.find("." + i.currentSlide).addClass(i.animateOut);
            },
            afterSlideChange: function (e, t, n) {
              t.$slider.find("." + i.allSlides).removeClass(i.animateOut);
            },
            destroy: function () {
              this.$slideshow.slick("unslick");
            },
            _play: function () {
              this.$slideshow.slick("slickPause"), e(i.pauseButton).addClass("is-paused");
            },
            _pause: function () {
              this.$slideshow.slick("slickPlay"), e(i.pauseButton).removeClass("is-paused");
            },
            _togglePause: function () {
              var t = this._getSlideshowId(this.$pause);
              this.$pause.hasClass(i.isPaused) ? (this.$pause.removeClass(i.isPaused), e(t).slick("slickPlay")) : (this.$pause.addClass(i.isPaused), e(t).slick("slickPause"));
            },
            _getSlideshowId: function (e) {
              return "#Slideshow-" + e.data("id");
            },
            _activeSlide: function () {
              return this.$slideshow.find(".slick-active");
            },
            _currentSlide: function () {
              return this.$slideshow.find(".slick-current");
            },
            _nextSlide: function (e) {
              return this.$slideshow.find('.slideshow__slide[data-slick-index="' + e + '"]');
            },
            _a11y: function () {
              var t = this.$slideshowList,
                n = this.settings.autoplay;
              t &&
                (t.removeAttr("aria-live"),
                e(i.wrapper).on(
                  "focusin",
                  function (o) {
                    e(i.wrapper).has(o.target).length && (t.attr("aria-live", "polite"), n && this._pause());
                  }.bind(this)
                ),
                e(i.wrapper).on(
                  "focusout",
                  function (o) {
                    e(i.wrapper).has(o.target).length && (t.removeAttr("aria-live"), n && this._play());
                  }.bind(this)
                ));
            },
            _clonedLazyloading: function () {
              var t = this.$slideshow;
              t.find(".slick-slide").each(
                function (i, n) {
                  var o = e(n);
                  if (o.hasClass("slick-cloned")) {
                    var a = o.data("id"),
                      s = o.find(".hero__image").removeClass("lazyloading").addClass("lazyloaded");
                    setTimeout(function () {
                      var e = t.find(".slideshow__slide--" + a + ":not(.slick-cloned) .hero__image").attr("style");
                      e && s.attr("style", e);
                    }, this.settings.autoplaySpeed / 1.5);
                  }
                }.bind(this)
              );
            },
          })),
          t
        );
      })()),
      (theme.announcementBar = (function () {
        function t() {
          e(a.bar).removeClass(s.closed), i();
        }
        function i() {
          var t = e(a.text).outerHeight(!0);
          e(a.bar).addClass(s.opening).css({ "max-height": t });
        }
        function n() {
          theme.config.hasSessionStorage && sessionStorage.setItem(o(), "hidden"), e(a.bar).addClass(s.closed);
        }
        function o() {
          return e(a.text).data("text");
        }
        var a = { bar: ".announcement", text: ".announcement__text", closeBtn: ".announcement__close" },
          s = { opening: "announcement--opening", closed: "announcement--closed" },
          r = { namespace: ".announcementBar" };
        return {
          init: function () {
            e(a.closeBtn).length &&
              (theme.config.hasSessionStorage &&
                "hidden" !== sessionStorage[o()] &&
                window.setTimeout(function () {
                  t();
                }, 2e3),
              theme.config.hasSessionStorage ||
                window.setTimeout(function () {
                  t();
                }, 2e3),
              e(a.closeBtn).on("click", function (e) {
                e.preventDefault(), n();
              }),
              e(window).on("resize" + r.namespace, e.debounce(150, i)));
          },
          unload: function () {
            e(window).off(r.namespace);
          },
        };
      })()),
      (theme.predictiveSearch = (function () {
        function t() {
          e(p.wrapper).addClass("hide"), clearTimeout(c);
        }
        function i() {
          e(p.form).trigger("submit");
        }
        function n(t) {
          var i = e(this);
          t.preventDefault ? t.preventDefault() : (t.returnValue = !1);
          var n = i.serializeArray().reduce(function (e, t) {
            return (e[t.name] = t.value), e;
          }, {});
          n.q && (n.q += "*");
          var o = e.param(n);
          return (window.location.href = "/search?" + o), !1;
        }
        function o(e) {
          return e.keyCode === m.up_arrow ? void 0 : e.keyCode === m.down_arrow ? void 0 : void (e.keyCode !== m.tab && a());
        }
        function a() {
          var i = e(p.input, p.form).val();
          if ("" !== i) {
            var n = (function (e) {
              return "string" != typeof e ? null : e.trim().replace(/\ /g, "-").toLowerCase();
            })(i);
            clearTimeout(c),
              (c = setTimeout(
                function () {
                  var i;
                  (i = n),
                    h ||
                      (l !== i &&
                        ((l = i),
                        (h = !0),
                        jQuery
                          .getJSON("/search/suggest.json", { q: i, resources: { type: theme.settings.predictiveSearchType, limit: 3, options: { unavailable_products: "last", fields: "title,product_type,variants.title,vendor" } } })
                          .done(function (n) {
                            h = !1;
                            var o = {},
                              a = 0;
                            e(p.wrapper).removeClass("hide");
                            for (var c = Object.entries(n.resources.results), l = c.length - 1; l >= 0; l--) {
                              var u = c[l],
                                m = u[0],
                                f = u[1];
                              switch (((a += f.length), m)) {
                                case "products":
                                  o[m] = s(f);
                                  break;
                                case "collections":
                                  o[m] = r(f);
                                  break;
                                default:
                                  o[m] = d(f);
                              }
                            }
                            0 === a && t(), e(p.resultDiv).empty().append(resultTemplate(o)), e(p.searchTerm, p.wrapper).text(i);
                          })));
                }.bind(this),
                500
              ));
          } else t();
        }
        function s(e) {
          for (var t = [], i = e.length - 1; i >= 0; i--) {
            var n = e[i],
              o = {
                title: n.title,
                url: n.url,
                image: theme.Images.getSizedImageUrl(n.image, "200x200_crop_center"),
                vendor: n.vendor,
                price: theme.Currency.formatMoney(n.price),
                compare_price_max: theme.Currency.formatMoney(n.compare_at_price_max),
                on_sale: parseInt(n.compare_at_price_max) > parseInt(n.price),
              };
            t.push(o);
          }
          return t;
        }
        function r(e) {
          for (var t = [], i = e.length - 1; i >= 0; i--) {
            var n = e[i],
              o = { title: n.title, url: n.url };
            n.featured_image.url && (o.image = theme.Images.getSizedImageUrl(n.featured_image.url, "200x200_crop_center")), t.push(o);
          }
          return t;
        }
        function d(e) {
          for (var t = e.length - 1; t >= 0; t--)
            if (e[t].image) {
              var i = theme.Images.getSizedImageUrl(e[t].image, "200x200_crop_center");
              e[t].image = i;
            }
          return e;
        }
        var c,
          l = "",
          h = !1,
          u = ".predictive",
          p = {
            form: "#HeaderSearchForm",
            input: 'input[type="search"]',
            wrapper: ".predictive-results",
            searchButton: "[data-predictive-search-button]",
            searchTerm: "[data-predictive-search-term]",
            resultDiv: "#PredictiveResults",
            resultTemplate: "#PredictiveTemplate",
          },
          m = { up_arrow: 38, down_arrow: 40, tab: 9 };
        return {
          init: function () {
            if (theme.settings.predictiveSearch) {
              if (document.getElementById("shopify-features") && !JSON.parse(document.getElementById("shopify-features").innerHTML).predictiveSearch) return;
              e(p.form).attr("autocomplete", "off"), e(p.form).on("submit" + u, n), e(p.input, p.form).on("keyup" + u, o), e(p.searchButton, p.wrapper).on("click" + u, i);
              var t = e(p.resultTemplate).html();
              resultTemplate = Handlebars.compile(t);
            }
          },
        };
      })()),
      (theme.initQuickShop = function (t) {
        var i = [];
        e(".quick-product__btn").each(function () {
          var t = e(this).data("product-id"),
            n = "QuickShopModal-" + t,
            o = "quick-modal-" + t;
          return i.indexOf(t) > -1
            ? void e('.modal--quick-shop[data-product-id="' + t + '"]').each(function (t) {
                t > 0 && e(this).remove();
              })
            : (new theme.Modals(n, o), void i.push(t));
        });
      }),
      (theme.videoModal = function () {
        function t(t) {
          var i = (function (e) {
              var t = e.match(/^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/);
              return !(!t || 11 != t[7].length) && t[7];
            })(e(t.currentTarget).attr("href")),
            r = e.extend({}, o, { videoId: i });
          (r.playerVars.playsinline = theme.config.bpSmall ? 0 : 1), (n = new YT.Player(a, r)), d.open(t), (s = "youtube");
        }
        function i() {
          e(r.videoHolder).empty();
        }
        var n = null,
          o = {
            width: 1280,
            height: 720,
            playerVars: { autohide: 0, autoplay: 1, branding: 0, cc_load_policy: 0, fs: 0, iv_load_policy: 3, modestbranding: 1, playsinline: 1, quality: "hd720", rel: 0, showinfo: 0, wmode: "opaque" },
            events: {
              onReady: function (e) {
                e.target.playVideo();
              },
            },
          },
          a = "VideoHolder",
          s = !1,
          r = { videoHolder: "#" + a, youtube: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]', mp4Trigger: ".product-video-trigger--mp4", mp4Player: ".product-video-mp4-sound" };
        if (e(r.youtube).length || e(r.mp4Trigger).length) {
          var d = new theme.Modals("VideoModal", "video-modal", { closeOffContentClick: !0, solid: !0 });
          e(r.youtube).on("click", function (n) {
            i(),
              n.preventDefault(),
              theme.LibraryLoader.load("youtubeSdk"),
              theme.config.youTubeReady
                ? t(n)
                : e("body").on("youTubeReady", function () {
                    t(n);
                  });
          }),
            e(r.mp4Trigger).on("click", function (t) {
              i(), e(t.currentTarget).next(r.mp4Player).clone().removeClass("hide").appendTo(r.videoHolder), d.open(t), e(r.videoHolder).find("video")[0].play(), (s = "mp4");
            }),
            e("body").on("modalClose.VideoModal", function () {
              n && "youtube" === s
                ? setTimeout(function () {
                    n.destroy();
                  }, 500)
                : i();
            });
        }
      }),
      (theme.parallaxSections = {}),
      (theme.Parallax = (function () {
        function t(t, i) {
          (this.$container = e(t)), (this.namespace = i.namespace), this.$container.length && (i.desktopOnly ? this.desktopInit() : this.init(this.$container, i));
        }
        return (
          (t.prototype = e.extend({}, t.prototype, {
            init: function (t) {
              var i = (this.$window = e(window)),
                n = this.$container.offset().top;
              i.on(
                "scroll" + this.namespace,
                function (e) {
                  var t = i.scrollTop(),
                    o = (n - t) / 7;
                  this.$container.css({ transform: "translate3d(0, " + o + "px, 0)" });
                }.bind(this)
              ),
                i.on(
                  "resize" + this.namespace,
                  e.debounce(
                    350,
                    function () {
                      return i.off(this.namespace), t && !theme.config.bpSmall ? void this.init(!0) : void this.init();
                    }.bind(this)
                  )
                );
            },
            desktopInit: function () {
              theme.config.bpSmall || this.init(!0),
                e("body").on(
                  "matchSmall",
                  function () {
                    this.destroy();
                  }.bind(this)
                ),
                e("body").on(
                  "matchLarge",
                  function () {
                    this.init(!0);
                  }.bind(this)
                );
            },
            destroy: function () {
              this.$container.removeAttr("style"), this.$window.off(this.namespace);
            },
          })),
          t
        );
      })()),
      (theme.Disclosure = (function () {
        function t(e) {
          (this.$container = e), (this.cache = {}), this._cacheSelectors(), this._connectOptions(), this._connectToggle(), this._onFocusOut();
        }
        var i = "[data-disclosure-list]",
          n = "[data-disclosure-toggle]",
          o = "[data-disclosure-input]",
          a = "[data-disclosure-option]",
          s = "disclosure-list--visible";
        return (
          (t.prototype = e.extend({}, t.prototype, {
            _cacheSelectors: function () {
              this.cache = { $disclosureList: this.$container.find(i), $disclosureToggle: this.$container.find(n), $disclosureInput: this.$container.find(o), $disclosureOptions: this.$container.find(a) };
            },
            _connectToggle: function () {
              this.cache.$disclosureToggle.on(
                "click",
                function (t) {
                  var i = "true" === e(t.currentTarget).attr("aria-expanded");
                  e(t.currentTarget).attr("aria-expanded", !i), this.cache.$disclosureList.toggleClass(s);
                }.bind(this)
              );
            },
            _connectOptions: function () {
              this.cache.$disclosureOptions.on(
                "click",
                function (t) {
                  t.preventDefault(), this._submitForm(e(t.currentTarget).data("value"));
                }.bind(this)
              );
            },
            _onFocusOut: function () {
              this.cache.$disclosureToggle.on(
                "focusout",
                function (e) {
                  0 === this.$container.has(e.relatedTarget).length && this._hideList();
                }.bind(this)
              ),
                this.cache.$disclosureList.on(
                  "focusout",
                  function (t) {
                    var i = e(t.currentTarget).has(t.relatedTarget).length > 0;
                    this.cache.$disclosureList.hasClass(s) && !i && this._hideList();
                  }.bind(this)
                ),
                this.$container.on(
                  "keyup",
                  function (e) {
                    27 === e.which && (this._hideList(), this.cache.$disclosureToggle.focus());
                  }.bind(this)
                ),
                e("body").on(
                  "click",
                  function (e) {
                    var t = this.$container.has(e.target).length > 0;
                    this.cache.$disclosureList.hasClass(s) && !t && this._hideList();
                  }.bind(this)
                );
            },
            _submitForm: function (t) {
              e("body").addClass("unloading"), this.cache.$disclosureInput.val(t), this.$container.parents("form").submit();
            },
            _hideList: function () {
              this.cache.$disclosureList.removeClass(s), this.cache.$disclosureToggle.attr("aria-expanded", !1);
            },
            unload: function () {
              this.cache.$disclosureOptions.off(), this.cache.$disclosureToggle.off(), this.cache.$disclosureList.off(), this.$container.off();
            },
          })),
          t
        );
      })()),
      (theme.ProductMedia = (function () {
        function t(i) {
          if (!i) {
            if (!window.ShopifyXR)
              return void document.addEventListener("shopify_xr_initialized", function () {
                t();
              });
            for (var n in o)
              if (o.hasOwnProperty(n)) {
                var a = o[n];
                if (a.loaded) continue;
                var s = e("#ModelJson-" + n);
                window.ShopifyXR.addModels(JSON.parse(s.html())), (a.loaded = !0);
              }
            window.ShopifyXR.setupXRElements();
          }
        }
        function i(e) {
          if (!e)
            for (var t in a)
              if (a.hasOwnProperty(t)) {
                var i = a[t];
                i.modelViewerUi || (i.modelViewerUi = new Shopify.ModelViewerUI(i.$element)), n(i);
              }
        }
        function n(e) {
          var t = s[e.sectionId];
          e.$container.on("mediaVisible", function () {
            t.$element.attr("data-shopify-model3d-id", e.modelId), theme.config.isTouch || e.modelViewerUi.play();
          }),
            e.$container
              .on("mediaHidden", function () {
                t.$element.attr("data-shopify-model3d-id", t.defaultId), e.modelViewerUi.pause();
              })
              .on("xrLaunch", function () {
                e.modelViewerUi.pause();
              });
        }
        var o = {},
          a = {},
          s = {},
          r = { mediaGroup: "[data-product-single-media-group]", xrButton: "[data-shopify-xr]" };
        return {
          init: function (n, d) {
            (o[d] = { loaded: !1 }),
              n.each(function (t) {
                var i = e(this),
                  n = i.data("media-id"),
                  o = e(i.find("model-viewer")[0]),
                  c = o.data("model-id");
                if (0 === t) {
                  var l = i.closest(r.mediaGroup).find(r.xrButton);
                  s[d] = { $element: l, defaultId: c };
                }
                a[n] = { modelId: c, sectionId: d, $container: i, $element: o };
              }),
              window.Shopify.loadFeatures([
                { name: "shopify-xr", version: "1.0", onLoad: t },
                { name: "model-viewer-ui", version: "1.0", onLoad: i },
              ]),
              theme.LibraryLoader.load("modelViewerUiStyles");
          },
          removeSectionModels: function (e) {
            for (var t in a) a.hasOwnProperty(t) && a[t].sectionId === e && delete a[t];
            delete o[e];
          },
        };
      })()),
      (theme.customerTemplates = (function () {
        function t() {
          e("#RecoverPasswordForm").toggleClass("hide"), e("#CustomerLoginForm").toggleClass("hide");
        }
        return {
          init: function () {
            "#recover" === window.location.hash && t(),
              e("#RecoverPassword").on("click", function (e) {
                e.preventDefault(), t();
              }),
              e("#HideRecoverPasswordLink").on("click", function (e) {
                e.preventDefault(), t();
              }),
              e(".reset-password-success").length && e("#ResetSuccess").removeClass("hide"),
              (function () {
                var t = e("#AddressNewForm"),
                  i = e(".js-address-form");
                t.length &&
                  i.length &&
                  (Shopify &&
                    e(".js-address-country").each(function () {
                      var t = e(this),
                        i = t.data("country-id"),
                        n = t.data("province-id"),
                        o = t.data("province-container-id");
                      new Shopify.CountryProvinceSelector(i, n, { hideElement: o });
                    }),
                  e(".address-new-toggle").on("click", function () {
                    t.toggleClass("hide");
                  }),
                  e(".address-edit-toggle").on("click", function () {
                    var t = e(this).data("form-id");
                    e("#EditAddress_" + t).toggleClass("hide");
                  }),
                  e(".address-delete").on("click", function () {
                    var t = e(this),
                      i = t.data("form-id"),
                      n = t.data("confirm-message");
                    confirm(n || "Are you sure you wish to delete this address?") && Shopify.postLink("/account/addresses/" + i, { parameters: { _method: "delete" } });
                  }));
              })();
          },
        };
      })()),
      (theme.Product = (function () {
        function t(t, n) {
          var o = e("#" + n),
            r = o.attr("id");
          (u[r] = t.target), u[r], a(o), "muted" === h[r].style ? u[r].mute() : s(o), (o.closest(l.startingSlide).length || 1 === o.data("image-count")) && "muted" === h[r].style && (u[r].playVideo(), i(r));
        }
        function i(t) {
          n(t), e(window).on("scroll." + t, { id: t }, e.throttle(150, n));
        }
        function n(t) {
          var i;
          if ("string" == typeof t) i = t;
          else {
            if (!t.data) return;
            i = t.data.id;
          }
          if (theme.isElementVisible(e("#" + i))) {
            if (h[i] && "unmuted" === h[i].style) return;
            !(function (e) {
              u[e] && "function" == typeof u[e].playVideo && u[e].playVideo();
            })(i);
          } else
            !(function (e) {
              u[e] && "function" == typeof u[e].pauseVideo && u[e].pauseVideo();
            })(i);
        }
        function o(t, i) {
          var n = e("#" + i),
            o = n.attr("id"),
            a = u[o];
          switch (t.data) {
            case -1:
              h[o].attemptedToPlay &&
                (s(n),
                (function (e) {
                  e.closest(l.videoParent).addClass(c.interactable);
                })(n));
              break;
            case 0:
              h[o] && h[o].loop && a.playVideo();
              break;
            case 1:
              s(n);
              break;
            case 3:
              h[o].attemptedToPlay = !0;
          }
        }
        function a(e) {
          e.closest(l.videoParent).addClass(c.loading);
        }
        function s(e) {
          e.closest(l.videoParent).removeClass(c.loading).addClass(c.loaded);
        }
        function r(t) {
          var i = (this.$container = e(t)),
            n = (this.sectionId = i.attr("data-section-id"));
          (this.inModal = i.closest(".modal").length),
            this.$modal,
            (this.settings = {
              enableHistoryState: i.data("enable-history-state") || !1,
              namespace: ".product-" + n,
              inventory: i.data("inventory") || !1,
              incomingInventory: i.data("incoming-inventory") || !1,
              modalInit: !1,
              slickMainInitialized: !1,
              slickThumbInitialized: !1,
              thumbArrows: !1,
              thumbVertical: !1,
              hasImages: !0,
              hasMultipleImages: !1,
              imageSize: "620x",
              currentSlideIndex: 0,
              videoLooping: i.data("video-looping"),
            }),
            this.inModal && ((this.settings.enableHistoryState = !1), (this.settings.namespace = ".product-" + n + "-modal"), (this.$modal = e("#QuickShopModal-" + n))),
            (this.selectors = {
              variantsJson: "VariantsJson-" + n,
              currentVariantJson: "CurrentVariantJson-" + n,
              media: "[data-product-media-type-model]",
              closeMedia: ".product-single__close-media",
              photoThumbs: ".product__thumb-" + n,
              thumbSlider: "#ProductThumbs-" + n,
              mainSlider: "#ProductPhotos-" + n,
              imageContainer: "[data-product-images]",
              productImageMain: ".product-image-main--" + n,
              dotsContainer: ".product__photo-dots--" + n,
              priceWrapper: ".product__price-wrap-" + n,
              price: "#ProductPrice-" + n,
              comparePrice: "#ComparePrice-" + n,
              priceA11y: "#PriceA11y-" + n,
              comparePriceA11y: "#ComparePriceA11y-" + n,
              unitWrapper: ".product__unit-price-wrapper--" + n,
              unitPrice: ".product__unit-price--" + n,
              unitPriceBaseUnit: ".product__unit-base--" + n,
              sku: "#Sku-" + n,
              inventory: "#ProductInventory-" + n,
              incomingInventory: "#ProductIncomingInventory-" + n,
              addToCart: "#AddToCart-" + n,
              addToCartText: "#AddToCartText-" + n,
              originalSelectorId: "#ProductSelect-" + n,
              singleOptionSelector: ".variant__input-" + n,
              variantColorSwatch: ".variant__input--color-swatch-" + n,
              modalFormHolder: "#ProductFormHolder-" + n,
              formContainer: "#AddToCartForm-" + n,
            }),
            (this.$mainSlider = e(this.selectors.mainSlider)),
            (this.$thumbSlider = e(this.selectors.thumbSlider)),
            (this.$firstProductImage = this.$mainSlider.find("img").first()),
            this.$firstProductImage.length || (this.settings.hasImages = !1),
            this.init();
        }
        var d,
          c = { onSale: "sale-price", disabled: "disabled", isModal: "is-modal", loading: "loading", loaded: "loaded", hidden: "hide", interactable: "video-interactable", visuallyHide: "visually-invisible" },
          l = { productVideo: ".product__video", videoParent: ".product__video-wrapper", currentSlide: ".slick-current", startingSlide: ".starting-slide" },
          h = {},
          u = [],
          p = {
            height: "480",
            width: "850",
            playerVars: { autohide: 0, autoplay: 0, branding: 0, cc_load_policy: 0, controls: 0, fs: 0, iv_load_policy: 3, modestbranding: 1, playsinline: 1, quality: "hd720", rel: 0, showinfo: 0, wmode: "opaque" },
          };
        return (
          (r.prototype = e.extend({}, r.prototype, {
            init: function () {
              this.inModal &&
                (this.$container.addClass(c.isModal),
                e("body")
                  .off("modalOpen.QuickShopModal-" + this.sectionId)
                  .off("modalClose.QuickShopModal-" + this.sectionId),
                e("body").on("modalOpen.QuickShopModal-" + this.sectionId, this.openModalProduct.bind(this)),
                e("body").on("modalClose.QuickShopModal-" + this.sectionId, this.closeModalProduct.bind(this))),
                this.inModal || (this.stringOverrides(), this.formSetup(), this.productSetup(), this.checkIfVideos(), this.createImageCarousels(), this.customMediaListners());
            },
            formSetup: function () {
              theme.settings.dynamicVariantsEnable && (this.$variantSelectors = e(this.selectors.formContainer).find(this.selectors.singleOptionSelector)), this.initQtySelector(), this.initAjaxProductForm(), this.initVariants();
            },
            productSetup: function () {
              this.setImageSizes(), this.initImageSwitch(), this.initImageZoom(), this.initModelViewerLibraries(), this.initShopifyXrLaunch();
            },
            stringOverrides: function () {
              (theme.productStrings = theme.productStrings || {}), e.extend(theme.strings, theme.productStrings);
            },
            setImageSizes: function () {
              if (this.settings.hasImages) {
                var e = this.$firstProductImage[0].currentSrc;
                e && (this.settings.imageSize = theme.Images.imageSize(e));
              }
            },
            initVariants: function () {
              if (document.getElementById(this.selectors.variantsJson)) {
                this.variantsObject = JSON.parse(document.getElementById(this.selectors.variantsJson).innerHTML);
                var t = {
                  $container: this.$container,
                  enableHistoryState: this.settings.enableHistoryState,
                  singleOptionSelector: this.selectors.singleOptionSelector,
                  originalSelectorId: this.selectors.originalSelectorId,
                  variants: this.variantsObject,
                };
                e(this.selectors.variantColorSwatch).length &&
                  e(this.selectors.variantColorSwatch).on(
                    "change",
                    function (t) {
                      var i = e(t.currentTarget),
                        n = i.data("color-name"),
                        o = i.data("color-index");
                      this.updateColorName(n, o);
                    }.bind(this)
                  ),
                  (this.variants = new theme.Variants(t)),
                  this.$container
                    .on("variantChange" + this.settings.namespace, this.updateCartButton.bind(this))
                    .on("variantImageChange" + this.settings.namespace, this.updateVariantImage.bind(this))
                    .on("variantPriceChange" + this.settings.namespace, this.updatePrice.bind(this))
                    .on("variantUnitPriceChange" + this.settings.namespace, this.updateUnitPrice.bind(this)),
                  e(this.selectors.sku).length && this.$container.on("variantSKUChange" + this.settings.namespace, this.updateSku.bind(this)),
                  (this.settings.inventory || this.settings.incomingInventory) && this.$container.on("variantChange" + this.settings.namespace, this.updateInventory.bind(this)),
                  theme.settings.dynamicVariantsEnable &&
                    document.getElementById(this.selectors.currentVariantJson) &&
                    ((this.currentVariantObject = JSON.parse(document.getElementById(this.selectors.currentVariantJson).innerHTML)),
                    this.$variantSelectors.on("change" + this.settings.namespace, this.updateVariantAvailability.bind(this)),
                    this.setCurrentVariantAvailability(this.currentVariantObject, !0));
              }
            },
            updateColorName: function (t, i) {
              e("#VariantColorLabel-" + this.sectionId + "-" + i).text(t);
            },
            initQtySelector: function () {
              this.$container.find(".js-qty__wrapper").each(function () {
                new theme.QtySelector(e(this), { namespace: ".product" });
              });
            },
            initAjaxProductForm: function () {
              "drawer" === theme.settings.cartType && new theme.AjaxProduct(e(this.selectors.formContainer));
            },
            setCurrentVariantAvailability: function (t) {
              var i = { option1: [], option2: [], option3: [] };
              this.disableVariantGroup(e(this.selectors.formContainer).find(".variant-input-wrap"));
              var n = this.variantsObject.filter(function (e) {
                  return t.id !== e.id && ((t.option2 === e.option2 && t.option3 === e.option3) || (t.option1 === e.option1 && t.option3 === e.option3) || (t.option1 === e.option1 && t.option2 === e.option2) || void 0);
                }),
                o = { variant: t };
              for (var a in (n = Object.assign({}, o, n)))
                if (n.hasOwnProperty(a)) {
                  var s = n[a],
                    r = s.option1,
                    d = s.option2,
                    c = s.option3;
                  r && -1 === i.option1.indexOf(r) && i.option1.push(r), d && -1 === i.option2.indexOf(d) && i.option2.push(d), c && -1 === i.option3.indexOf(c) && i.option3.push(c);
                }
              i.option1.length && this.enableVariantOptionByValue(i.option1, "option1"), i.option2.length && this.enableVariantOptionByValue(i.option2, "option2"), i.option3.length && this.enableVariantOptionByValue(i.option3, "option3");
            },
            updateVariantAvailability: function (t, i, n) {
              if (i && n)
                var o = i,
                  a = n;
              else {
                var s = e(t.currentTarget);
                (o = s.val() ? s.val() : t.currentTarget.value), (a = s.data("index"));
              }
              var r = this.variantsObject.filter(function (e) {
                return e[a] === o;
              });
              e(this.selectors.formContainer)
                .find(".variant-input-wrap")
                .each(
                  function (t, i) {
                    var n = e(i),
                      o = n.data("index");
                    if (o !== a) {
                      this.disableVariantGroup(n);
                      for (var s = 0; s < r.length; s++) this.enableVariantOption(n, r[s][o]);
                    }
                  }.bind(this)
                );
            },
            disableVariantGroup: function (e) {
              "dropdown" === theme.settings.dynamicVariantType ? e.find("option").prop("disabled", !0) : (e.find("input").prop("disabled", !0), e.find("label").toggleClass("disabled", !0));
            },
            enableVariantOptionByValue: function (t, i) {
              for (var n = e(this.selectors.formContainer).find('.variant-input-wrap[data-index="' + i + '"]'), o = 0; o < t.length; o++) this.enableVariantOption(n, t[o]);
            },
            enableVariantOption: function (e, t) {
              if (((t = t.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, "\\$1")), "dropdown" === theme.settings.dynamicVariantType)) e.find('option[value="' + t + '"]').prop("disabled", !1);
              else {
                var i = e.find('.variant-input[data-value="' + t + '"]');
                i.find("input").prop("disabled", !1), i.find("label").toggleClass("disabled", !1);
              }
            },
            updateCartButton: function (t) {
              var i = t.variant;
              if (i)
                if (i.available) {
                  e(this.selectors.addToCart).removeClass(c.disabled).prop("disabled", !1);
                  var n = e(this.selectors.addToCartText).data("default-text");
                  e(this.selectors.addToCartText).html(n);
                } else e(this.selectors.addToCart).addClass(c.disabled).prop("disabled", !0), e(this.selectors.addToCartText).html(theme.strings.soldOut);
              else e(this.selectors.addToCart).addClass(c.disabled).prop("disabled", !0), e(this.selectors.addToCartText).html(theme.strings.unavailable);
            },
            updatePrice: function (t) {
              var i = t.variant;
              i &&
                (e(this.selectors.price).html(theme.Currency.formatMoney(i.price, theme.settings.moneyFormat)).show(),
                i.compare_at_price > i.price
                  ? (e(this.selectors.comparePrice).html(theme.Currency.formatMoney(i.compare_at_price, theme.settings.moneyFormat)),
                    e(this.selectors.priceWrapper).removeClass(c.hidden),
                    e(this.selectors.price).addClass(c.onSale),
                    e(this.selectors.comparePriceA11y).attr("aria-hidden", "false"),
                    e(this.selectors.priceA11y).attr("aria-hidden", "false"))
                  : (e(this.selectors.priceWrapper).addClass(c.hidden),
                    e(this.selectors.price).removeClass(c.onSale),
                    e(this.selectors.comparePriceA11y).attr("aria-hidden", "true"),
                    e(this.selectors.priceA11y).attr("aria-hidden", "true")));
            },
            updateUnitPrice: function (t) {
              var i = t.variant;
              i && i.unit_price
                ? (e(this.selectors.unitPrice).html(theme.Currency.formatMoney(i.unit_price, theme.settings.moneyFormat)),
                  e(this.selectors.unitPriceBaseUnit).text(theme.Currency.getBaseUnit(i)),
                  e(this.selectors.unitWrapper).removeClass(c.hidden).removeClass(c.visuallyHide))
                : e(this.selectors.unitWrapper).addClass(c.visuallyHide);
            },
            updateSku: function (t) {
              var i = t.variant,
                n = "";
              i && (i.sku && (n = i.sku), e(this.selectors.sku).html(n));
            },
            updateInventory: function (e) {
              var t = e.variant;
              if (!t || !t.inventory_management || "continue" === t.inventory_policy) return this.toggleInventoryQuantity(!1), void this.toggleIncomingInventory(!1);
              if ("shopify" === t.inventory_management && window.inventories && window.inventories[this.sectionId]) {
                variantInventoryObject = window.inventories[this.sectionId][t.id];
                var i = variantInventoryObject.quantity,
                  n = !0,
                  o = !1;
                (0 >= i || i > theme.settings.inventoryThreshold) && (n = !1),
                  this.toggleInventoryQuantity(n, i),
                  !n && variantInventoryObject.incoming && (o = !0),
                  this.toggleIncomingInventory(o, t.available, variantInventoryObject.next_incoming_date);
              }
            },
            toggleInventoryQuantity: function (t, i) {
              this.settings.inventory || (t = !1), t ? e(this.selectors.inventory).removeClass(c.hidden).text(theme.strings.stockLabel.replace("[count]", i)) : e(this.selectors.inventory).addClass(c.hidden);
            },
            toggleIncomingInventory: function (t, i, n) {
              if ((this.settings.incomingInventory || (t = !1), t)) {
                var o = i ? theme.strings.willNotShipUntil.replace("[date]", n) : theme.strings.willBeInStockAfter.replace("[date]", n);
                n || (o = theme.strings.waitingForStock), e(this.selectors.incomingInventory).removeClass(c.hidden).text(o);
              } else e(this.selectors.incomingInventory).addClass(c.hidden);
            },
            checkIfVideos: function () {
              var t = this.$mainSlider.find(l.productVideo);
              if (!t.length) return !1;
              var i = [];
              return (
                t.each(function () {
                  var t = e(this).data("video-type");
                  i.indexOf(t) < 0 && i.push(t);
                }),
                i.indexOf("youtube") > -1 &&
                  (theme.config.youTubeReady
                    ? this.loadYoutubeVideos(t)
                    : (theme.LibraryLoader.load("youtubeSdk"),
                      e("body").on(
                        "youTubeReady" + this.settings.namespace,
                        function () {
                          this.loadYoutubeVideos(t);
                        }.bind(this)
                      ))),
                i.indexOf("mp4") > -1 && this.loadMp4Videos(t),
                i
              );
            },
            loadMp4Videos: function (t) {
              t.each(function () {
                var t = e(this);
                if ("mp4" == t.data("video-type")) {
                  var i = t.attr("id");
                  t.data("video-id"), (h[i] = { type: "mp4", divId: i, style: t.data("video-style") });
                }
              });
            },
            loadYoutubeVideos: function (i) {
              for (var n in (i.each(function () {
                var i = e(this);
                if ("youtube" == i.data("video-type")) {
                  var n = i.attr("id"),
                    a = i.data("youtube-id");
                  h[n] = {
                    type: "youtube",
                    id: n,
                    videoId: a,
                    style: i.data("video-style"),
                    loop: i.data("video-loop"),
                    attemptedToPlay: !1,
                    events: {
                      onReady: function (e) {
                        t(e, n);
                      },
                      onStateChange: function (e) {
                        o(e, n);
                      },
                    },
                  };
                }
              }),
              h))
                if ("youtube" === h[n].type && h.hasOwnProperty(n)) {
                  var a = e.extend({}, p, h[n]);
                  "muted" === a.style || ((a.playerVars.controls = 1), (a.playerVars.autoplay = 0)), (u[n] = new YT.Player(n, a));
                }
              d = !0;
            },
            initVideo: function (e) {
              var t = e.data("video-type"),
                i = e.attr("id");
              "mp4" === t && "muted" === h[i].style && this.playMp4Video(i), "youtube" === t && d && "muted" === h[i].style && this.requestToPlayYoutubeVideo(i), this.inModal && this.resizeSlides();
            },
            stopVideo: function (e, t) {
              e || (this.stopYoutubeVideo(), this.stopMp4Video()), "youtube" === t && this.stopYoutubeVideo(e), "mp4" === t && this.stopMp4Video(e);
            },
            getVideoType: function (e) {
              return e.data("video-type");
            },
            getVideoId: function (e) {
              return e.attr("id");
            },
            requestToPlayYoutubeVideo: function (t, i) {
              if (theme.config.youTubeReady)
                return (
                  a(e("#" + t)),
                  "function" != typeof u[t].playVideo
                    ? void setTimeout(
                        function () {
                          this.playYoutubeVideo(t, i);
                        }.bind(this),
                        1e3
                      )
                    : void this.playYoutubeVideo(t, i)
                );
            },
            playYoutubeVideo: function (t, n) {
              s(e("#" + t)), "function" == typeof u[t].playVideo && u[t].playVideo(), n || i(t);
            },
            stopYoutubeVideo: function (t) {
              if (theme.config.youTubeReady)
                if (t && u[t]) "function" == typeof u[t].pauseVideo && u[t].pauseVideo(), e(window).off("scroll." + t);
                else
                  for (key in u) {
                    this.$container.find("#" + key).length && "function" == typeof u[key].pauseVideo && (u[key].pauseVideo(), e(window).off("scroll." + key));
                  }
            },
            playMp4Video: function (t) {
              var i = e("#" + t);
              s(i);
              var n = i[0].play();
              void 0 !== n &&
                n
                  .then(function () {})
                  .catch(function (e) {
                    i[0].setAttribute("controls", ""), i.closest(l.videoParent).attr("data-video-style", "unmuted");
                  });
            },
            stopMp4Video: function (t) {
              if (t) e("#" + t)[0].pause();
              else
                for (var i in h) {
                  if (this.$container.find("#" + i).length && "mp4" === h[i].type) {
                    var n = e("#" + h[i].divId)[0];
                    n && "function" == typeof n.pause && n.pause();
                  }
                }
            },
            initImageSwitch: function () {
              e(this.selectors.photoThumbs).length &&
                e(this.selectors.photoThumbs)
                  .on("click", function (e) {
                    e.preventDefault();
                  })
                  .on(
                    "focus",
                    function (t) {
                      if (this.settings.slickThumbInitialized) {
                        var i = e(t.currentTarget).data("index");
                        void 0 !== i && this.$thumbSlider.slick("slickGoTo", i);
                      }
                    }.bind(this)
                  )
                  .on(
                    "keydown",
                    function (e) {
                      13 === e.keyCode && this.$container.find(l.currentSlide).focus();
                    }.bind(this)
                  );
            },
            initImageZoom: function () {
              var t = e(this.selectors.imageContainer, this.$container);
              new theme.Photoswipe(t[0], this.sectionId);
            },
            updateVariantImage: function (t) {
              var i = t.variant,
                n = (theme.Images.getSizedImageUrl(i.featured_media.preview_image.src, this.settings.imageSize), e('.product__thumb[data-id="' + i.featured_media.id + '"]')),
                o = this._slideIndex(n.closest(".product__thumb-item"));
              void 0 !== o && this.$mainSlider.slick("slickGoTo", o);
            },
            createImageCarousels: function () {
              if (!this.$thumbSlider.length || e(this.selectors.photoThumbs).length < 2) {
                var t = e(this.selectors.productImageMain).find(l.productVideo);
                t.length && this.initVideo(t);
              } else {
                this.settings.hasMultipleImages = !0;
                var i = this.$mainSlider.find(".starting-slide"),
                  n = this._slideIndex(i);
                this.$mainSlider.off("init"),
                  this.$mainSlider.off("beforeChange"),
                  this.$mainSlider.on("init", this.mainSlideInit.bind(this)),
                  this.$mainSlider.on("beforeChange", this.beforeSlideChange.bind(this)),
                  this.$thumbSlider.on("init", this.thumbSlideInit.bind(this));
                var o = (this.settings.thumbVertical = "beside" === this.$thumbSlider.data("position")),
                  a = (this.settings.thumbArrows = this.$thumbSlider.data("arrows"));
                this.$mainSlider.slick({ accessibility: !1, adaptiveHeight: false, asNavFor: this.selectors.thumbSlider, infinite: !1, arrows: !1, dots: !1, initialSlide: n, appendDots: this.selectors.dotsContainer }),
                  this.$thumbSlider.slick({
                    accessibility: !1,
                    asNavFor: this.selectors.mainSlider,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: a,
                    dots: o,
                    vertical: o,
                    verticalSwiping: o,
                    focusOnSelect: !0,
                    infinite: !1,
                    customHeightMatching: !a && o,
                    customSlideAdvancement: !0,
                    initialSlide: n,
                  }),
                  AOS && AOS.refresh();
              }
            },
            destroyImageCarousels: function () {
              this.$mainSlider && this.settings.slickMainInitialized && (this.$mainSlider.slick("unslick"), (this.settings.slickMainInitialized = !1)),
                this.$thumbSlider && this.settings.slickThumbInitialized && (this.$thumbSlider.slick("unslick"), (this.settings.slickThumbInitialized = !1)),
                (this.settings.slickMainInitialized = !1),
                (this.settings.slickThumbInitialized = !1);
            },
            mainSlideInit: function (e, t) {
              var i = t.$slider.find(l.currentSlide),
                n = i.find(l.productVideo);
              (this.settings.slickMainInitialized = !0), (this.settings.currentSlideIndex = i.data("slick-index")), n.length && this.initVideo(n);
            },
            thumbSlideInit: function (e, t) {
              (this.settings.slickThumbInitialized = !0), this.settings.thumbArrows && this.$thumbSlider.on("setPosition", this.thumbSlideArrowVisibility.bind(this));
            },
            thumbSlideArrowVisibility: function (e, t) {
              var i = t.$slider,
                n = i.find(".slick-arrow"),
                o = !1;
              this.settings.thumbVertical ? i.find(".slick-track").height() >= i.height() && (o = !0) : i.find(".slick-track").width() >= i.width() && (o = !0);
              o ? n.removeClass(c.hidden) : n.addClass(c.hidden);
            },
            beforeSlideChange: function (t, i, n, o) {
              if (this.settings.currentSlideIndex !== o) {
                this.settings.currentSlideIndex = o;
                var a = i.$slider,
                  r = a.find(l.currentSlide),
                  c = a.find('.slick-slide[data-slick-index="' + o + '"]');
                r.attr("tabindex", "-1"), c.attr("tabindex", 0);
                var u = r.find(".product__video");
                if (n !== o && u.length) {
                  var p = this.getVideoType(u),
                    m = this.getVideoId(u);
                  m && this.stopVideo(m, p);
                }
                var f = c.find(".product__video");
                if (f.length) {
                  var g = this.getVideoType(f),
                    v = this.getVideoId(f);
                  v &&
                    "youtube" === g &&
                    (d
                      ? h[v] && "muted" === h[v].style && this.requestToPlayYoutubeVideo(v, !0)
                      : e("body").on(
                          "youTubeReady" + this.settings.namespace,
                          function () {
                            h[v] && "muted" === h[v].style && this.requestToPlayYoutubeVideo(v, !0);
                          }.bind(this)
                        )),
                    v && h[v] && "muted" === h[v].style && "mp4" === g && this.playMp4Video(v),
                    v && h[v] && "muted" != h[v].style && s(e("#" + v));
                }
                var y = r.find(this.selectors.media);
                y.length && y.trigger("mediaHidden");
                var b = c.find(this.selectors.media);
                b.length && (b.trigger("mediaVisible"), c.find(".shopify-model-viewer-ui__button").attr("tabindex", 0), c.find(".product-single__close-media").attr("tabindex", 0));
              }
            },
            resizeSlides: function () {
              this.settings.hasMultipleImages &&
                (e(window).trigger("resize.slick"),
                setTimeout(
                  function () {
                    this.$mainSlider && this.settings.slickMainInitialized && this.$mainSlider.slick("setPosition"), this.$thumbSlider && this.settings.slickThumbInitialized && this.$thumbSlider.slick("setPosition");
                  }.bind(this),
                  500
                ));
            },
            _slideIndex: function (e) {
              return e.data("index");
            },
            openModalProduct: function () {
              if (!this.settings.modalInit) {
                var t = e(this.selectors.modalFormHolder),
                  i = t.data("url");
                t.data("template") || (i += "?view=ajax"),
                  t.load(
                    i + " #AddToCartForm-" + this.sectionId,
                    function () {
                      this.formSetup(), Shopify.PaymentButton && Shopify.PaymentButton.init();
                    }.bind(this)
                  ),
                  this.productSetup(),
                  this.loadModalContent(),
                  this.createImageCarousels(),
                  this.customMediaListners(),
                  (this.settings.modalInit = !0);
              }
              this.resizeSlides();
            },
            closeModalProduct: function () {
              this.stopVideo(), e("body").off(this.settings.namespace), e(window).off(this.settings.namespace);
            },
            loadModalContent: function () {
              var t = this.checkIfVideos();
              t &&
                t.indexOf("mp4") > -1 &&
                this.$modal
                  .find('.product__video[data-video-type="mp4"]')
                  .find(".product__video-src")
                  .each(
                    function (t, i) {
                      var n = e(i),
                        o = n.attr("src"),
                        a = n.attr("type"),
                        s = document.createElement("source");
                      (s.src = o), (s.type = a), n.after(s);
                    }.bind(this)
                  );
            },
            initModelViewerLibraries: function () {
              var t = e(this.selectors.media, this.$container);
              t.length < 1 || theme.ProductMedia.init(t, this.sectionId);
            },
            initShopifyXrLaunch: function () {
              var t = this;
              e(document).on("shopify_xr_launch", function () {
                e(t.selectors.productMediaWrapper + ":not(." + c.hidden + ")", t.$container).trigger("xrLaunch");
              });
            },
            customMediaListners: function () {
              e("body").on(
                "click",
                this.selectors.closeMedia,
                function () {
                  this.$mainSlider.find(l.currentSlide).find(this.selectors.media).trigger("mediaHidden");
                }.bind(this)
              ),
                this.$container
                  .find("model-viewer")
                  .on(
                    "shopify_model_viewer_ui_toggle_play",
                    function (e) {
                      this.mediaLoaded(e);
                    }.bind(this)
                  )
                  .on(
                    "shopify_model_viewer_ui_toggle_pause",
                    function (e) {
                      this.mediaUnloaded(e);
                    }.bind(this)
                  );
            },
            mediaLoaded: function (e) {
              this.$container.find(this.selectors.closeMedia).removeClass(c.hidden), this.toggleSliderSwiping(!1);
            },
            mediaUnloaded: function (e) {
              this.$container.find(this.selectors.closeMedia).addClass(c.hidden), this.toggleSliderSwiping(!0);
            },
            toggleSliderSwiping: function (e) {
              this.$mainSlider &&
                this.settings.slickMainInitialized &&
                (this.$mainSlider.slick("slickSetOption", "swipe", e),
                this.$mainSlider.slick("slickSetOption", "draggable", e),
                this.$mainSlider.slick("slickSetOption", "touchMove", e),
                this.$mainSlider.slick("slickSetOption", "accessibility", e));
            },
            onUnload: function () {
              this.$container.off(this.settings.namespace), e("body").off(this.settings.namespace), this.destroyImageCarousels(), theme.ProductMedia.removeSectionModels(this.sectionId);
            },
          })),
          r
        );
      })()),
      (theme.Recommendations = (function () {
        function t(t) {
          var i = (this.$container = e(t)),
            n = (this.sectionId = i.attr("data-section-id"));
          (this.url = i.data("url")),
            (this.selectors = { recommendations: "#Recommendations-" + n, placeholder: ".product-recommendations-placeholder", sectionClass: " .product-recommendations", productResults: ".grid-product" }),
            this.init();
        }
        return (
          (t.prototype = e.extend({}, t.prototype, {
            init: function () {
              var t = e(this.selectors.recommendations);
              if (t.length && !1 !== t.data("enable")) {
                var i = t.find(this.selectors.placeholder),
                  n = t.data("product-id"),
                  o = t.data("limit"),
                  a = this.url + "?section_id=product-recommendations&limit=" + o + "&product_id=" + n;
                i.load(
                  a + this.selectors.sectionClass,
                  function (i) {
                    theme.reinitProductGridItem(t), this.updateVariantInventory(t), 0 === e(i).find(this.selectors.sectionClass).find(this.selectors.productResults).length && t.addClass("hide");
                  }.bind(this)
                );
              }
            },
            updateVariantInventory: function (t) {
              (window.inventories = window.inventories || {}),
                t.find(".js-product-inventory-data").each(function () {
                  var t = e(this),
                    i = t.data("section-id");
                  (window.inventories[i] = {}),
                    e(".js-variant-inventory-data", t).each(function () {
                      var t = e(this);
                      window.inventories[i][t.data("id")] = { quantity: t.data("quantity"), incoming: t.data("incoming"), next_incoming_date: t.data("date") };
                    });
                });
            },
          })),
          t
        );
      })()),
      (theme.Collection = (function () {
        function t(t) {
          (this.container = t), (this.sectionId = e(t).attr("data-section-id")), (this.namespace = ".collection-" + this.sectionId);
          var i = (this.$heroContainer = e(t).find(".collection-hero"));
          if (i.length) {
            if ((this.checkIfNeedReload(), theme.loadImageSection(i), e(t).data("parallax"))) {
              var o = e(t).find(n.parallaxContainer),
                a = { namespace: this.namespace };
              theme.parallaxSections[this.namespace] = new theme.Parallax(o, a);
            }
          } else theme.settings.overlayHeader && theme.headerNav.disableOverlayHeader();
          e(window).on(
            "popstate",
            function (e) {
              e && this.getNewCollectionContent(location.href);
            }.bind(this)
          ),
            this.init();
        }
        var i = !1,
          n = { sortSelect: "#SortBy", tags: ".tags", hero: ".collection-hero", title: ".collection-title", parallaxContainer: ".parallax-container" },
          o = "data-default-sortby",
          a = "tag--active";
        return (
          (t.prototype = e.extend({}, t.prototype, {
            init: function () {
              (this.$container = e(this.container)),
                (this.sectionId = this.$container.attr("data-section-id")),
                (this.$sortSelect = e(n.sortSelect)),
                this.$sortSelect.on("change", this.onSortChange.bind(this)),
                (this.defaultSort = this.getDefaultSortValue()),
                this.initParams(),
                this.sortTags(),
                this.initTagAjax();
            },
            initTagAjax: function () {
              this.$container.on(
                "click" + this.namespace,
                ".tags a",
                function (t) {
                  var o = e(t.currentTarget);
                  if (!o.hasClass("no-ajax") && (t.preventDefault(), !i)) {
                    i = !0;
                    var s = o.attr("href");
                    e(n.tags)
                      .find("." + a)
                      .removeClass(a),
                      o.parent().addClass(a),
                      history.pushState({}, "", s),
                      e(".grid-product").addClass("unload"),
                      this.getNewCollectionContent(s);
                  }
                }.bind(this)
              );
            },
            getNewCollectionContent: function (t) {
              (t = -1 === t.indexOf("?") ? t + "?view=ajax" : t + "&view=ajax"),
                e("#CollectionAjaxResult").load(
                  t + " #CollectionAjaxContent",
                  function (e) {
                    (i = !1), this.reInit(e);
                  }.bind(this)
                );
            },
            initParams: function () {
              if (((this.queryParams = {}), location.search.length))
                for (var e, t = location.search.substr(1).split("&"), i = 0; i < t.length; i++) (e = t[i].split("=")).length > 1 && (this.queryParams[decodeURIComponent(e[0])] = decodeURIComponent(e[1]));
            },
            getSortValue: function () {
              return this.$sortSelect.val() || this.defaultSort;
            },
            getDefaultSortValue: function () {
              return this.$sortSelect.attr(o);
            },
            onSortChange: function () {
              (this.queryParams.sort_by = this.getSortValue()), this.queryParams.page && delete this.queryParams.page, (window.location.search = e.param(this.queryParams));
            },
            sortTags: function () {
              var t = e("#SortTags");
              t.length &&
                t.on("change", function () {
                  location.href = e(this).val();
                });
            },
            reInit: function (t) {
              for (var i = 0; i < sections.instances.length; i++) {
                var o = sections.instances[i];
                "collection-template" === o.type && o.forceReload();
              }
              if (t) {
                var a = e(t).find(n.title).text();
                e(n.title).text(a);
              }
              theme.reinitProductGridItem();
            },
            forceReload: function () {
              this.onUnload(), this.init();
            },
            checkIfNeedReload: function () {
              Shopify.designMode && theme.settings.overlayHeader && (e(".header-wrapper").hasClass("header-wrapper--overlay") || location.reload());
            },
            onUnload: function () {
              e(window).off(this.namespace), this.$container.off(this.namespace), theme.parallaxSections[this.namespace] && (theme.parallaxSections[this.namespace].destroy(), delete theme.parallaxSections[this.namespace]);
            },
          })),
          t
        );
      })()),
      (theme.CollectionSwitcher = (function () {
        function t(t) {
          (this.$container = e(t)),
            (this.sectionId = this.$container.attr("data-section-id")),
            (this.config = { perRow: this.$container.attr("data-per-row"), perRowMobile: 2 }),
            (this.sliderArgs = { arrows: !0, infinite: !1, slidesToShow: this.config.perRow, slidesToScroll: this.config.perRow }),
            (this.$activeSlider = null),
            this.init();
        }
        var i = ".collection-switcher__trigger",
          n = ".collection-switcher__collection",
          o = ".collection-switcher__collection-grid";
        return (
          (t.prototype = e.extend({}, t.prototype, {
            init: function () {
              (this.$triggers = this.$container.find(i)), (this.$collections = this.$container.find(n));
              var t = this.$container.find(o).first();
              t.length &&
                (this.initSlider(t),
                e("body").on(
                  "matchSmall unmatchSmall",
                  function () {
                    this.initSlider();
                  }.bind(this)
                )),
                this.$triggers.on("click", this.switch.bind(this));
            },
            initSlider: function (e) {
              this.$activeSlider && this.$activeSlider.off("afterChange").slick("unslick"),
                e || (e = this.$activeSlider),
                e.length &&
                  (theme.config.bpSmall
                    ? ((this.sliderArgs.slidesToShow = this.config.perRowMobile), (this.sliderArgs.slidesToScroll = this.config.perRowMobile))
                    : ((this.sliderArgs.slidesToShow = parseInt(this.config.perRow)), (this.sliderArgs.slidesToScroll = parseInt(this.config.perRow))),
                  (this.$activeSlider = e.slick(this.sliderArgs)),
                  AOS && AOS.refresh());
            },
            switch: function (t) {
              t.preventDefault(), this.$triggers.removeClass("is-active");
              var i = e(t.currentTarget).addClass("is-active").attr("aria-controls"),
                n = e("#" + i),
                a = n.find(o);
              this.$collections.addClass("hide"), n.removeClass("hide"), this.initSlider(a);
            },
            onUnload: function () {},
          })),
          t
        );
      })()),
      (theme.HeaderSection = (function () {
        function t(t) {
          for (var i = (this.$container = e(t)), n = ((this.sectionId = i.attr("data-section-id")), 0); n < sections.instances.length; n++) {
            var o = sections.instances[n];
            "slideshow-section" === o.type && o.forceReload();
          }
          this.initDrawers(), theme.headerNav.init(), theme.announcementBar.init();
        }
        var i = "#NavDrawer",
          n = ".mobile-nav__toggle-btn",
          o = ".mobile-nav__has-sublist",
          a = "mobile-nav--expanded";
        return (
          (t.prototype = e.extend({}, t.prototype, {
            initDrawers: function () {
              (theme.NavDrawer = new theme.Drawers("NavDrawer", "nav")), "drawer" === theme.settings.cartType && new theme.CartDrawer(), this.drawerMenuButtons();
            },
            drawerMenuButtons: function () {
              e(i)
                .find(".js-drawer-close")
                .on("click", function (e) {
                  e.preventDefault(), theme.NavDrawer.close();
                });
              var t = e(n);
              t.attr("aria-expanded", "false"),
                t.each(function (t, i) {
                  var n = e(i);
                  n.attr("aria-controls", n.attr("data-aria-controls"));
                }),
                t.on("click", function () {
                  var t = e(this),
                    i = !1;
                  "true" === t.attr("aria-expanded") ? t.attr("aria-expanded", "false") : (t.attr("aria-expanded", "true"), (i = !0)), t.closest(o).toggleClass(a, i);
                });
            },
            onUnload: function () {
              theme.NavDrawer.close(), theme.headerNav.unload(), theme.announcementBar.unload();
            },
          })),
          t
        );
      })()),
      (theme.FooterSection = (function () {
        function t(t) {
          (this.$container = e(t)),
            (this.cache = {}),
            this.cacheSelectors(),
            this.cache.$localeDisclosure.length && (this.localeDisclosure = new theme.Disclosure(this.cache.$localeDisclosure)),
            this.cache.$currencyDisclosure.length && (this.currencyDisclosure = new theme.Disclosure(this.cache.$currencyDisclosure));
        }
        var i = "[data-disclosure-locale]",
          n = "[data-disclosure-currency]";
        return (
          (t.prototype = e.extend({}, t.prototype, {
            cacheSelectors: function () {
              this.cache = { $localeDisclosure: this.$container.find(i), $currencyDisclosure: this.$container.find(n) };
            },
            onUnload: function () {
              this.cache.$localeDisclosure.length && this.localeDisclosure.unload(), this.cache.$currencyDisclosure.length && this.currencyDisclosure.unload();
            },
          })),
          t
        );
      })()),
      (theme.FeaturedContentSection = (function () {
        return function () {
          e(".rte").find("a:not(:has(img))").addClass("text-link");
        };
      })()),
      (theme.slideshows = {}),
      (theme.SlideshowSection = (function () {
        function t(t) {
          var n = (this.$container = e(t)),
            o = (n.parent(), n.attr("data-section-id"));
          (this.slideshow = "#Slideshow-" + o), (this.namespace = "." + o);
          var a = e(t).find(".hero");
          if ((a.length && theme.loadImageSection(a), this.init(), n.data("parallax"))) {
            var s = { namespace: this.namespace };
            theme.parallaxSections[this.namespace] = new theme.Parallax(n.find(i.parallaxContainer), s);
          }
        }
        var i = { parallaxContainer: ".parallax-container" };
        return (
          (t.prototype = e.extend({}, t.prototype, {
            init: function () {
              var t = { arrows: e(this.slideshow).data("arrows"), dots: e(this.slideshow).data("dots"), fade: !!this.$container.data("parallax"), speed: 500 };
              theme.slideshows[this.slideshow] = new theme.Slideshow(this.slideshow, t);
            },
            forceReload: function () {
              this.onUnload(), this.init();
            },
            onUnload: function () {
              theme.parallaxSections[this.namespace] && (theme.parallaxSections[this.namespace].destroy(), delete theme.parallaxSections[this.namespace]),
                theme.slideshows[this.slideshow] && (theme.slideshows[this.slideshow].destroy(), delete theme.slideshows[this.slideshow]);
            },
            onSelect: function () {
              e(this.slideshow).slick("slickPause");
            },
            onDeselect: function () {
              e(this.slideshow).slick("slickPlay");
            },
            onBlockSelect: function (t) {
              var i = e(this.slideshow),
                n = e(".slideshow__slide--" + t.detail.blockId + ":not(.slick-cloned)").data("slick-index");
              i.slick("slickGoTo", n).slick("slickPause");
            },
            onBlockDeselect: function () {
              e(this.slideshow).slick("slickPlay");
            },
          })),
          t
        );
      })()),
      (theme.VideoSection = (function () {
        function t(t) {
          var i = (this.$container = e(t)),
            n = ((this.sectionId = i.attr("data-section-id")), (this.youtubePlayerId = "YouTubeVideo-" + this.sectionId));
          this.namespace = "." + n;
          var o = (this.vimeoPlayerId = "Vimeo-" + this.sectionId),
            a = ((this.$vimeoTrigger = e("#VimeoTrigger-" + this.sectionId)), "Mp4Video-" + this.sectionId),
            d = e("#" + n),
            c = e("#" + o),
            l = e("#" + a);
          (this.vimeoPlayer = []),
            d.length && ((this.youtubeVideoId = d.data("video-id")), this.initYoutubeVideo()),
            c.length && ((this.vimeoVideoId = c.data("video-id")), this.initVimeoVideo()),
            l.length &&
              (s(l),
              (function (e) {
                return document.querySelector("#" + e).play();
              })(a)
                .then(function () {})
                .catch(function (e) {
                  l.attr("controls", ""), r(l);
                }));
        }
        function i(t, i) {
          var o = e("#" + i),
            s = o.attr("id");
          (l[s] = t.target), l[s], a(o), l[s].mute(), o.attr("tabindex", "-1"), n(s), e(window).on("scroll." + s, { id: s }, e.throttle(150, n));
        }
        function n(t) {
          var i;
          (i = "string" == typeof t ? t : t.data.id),
            theme.isElementVisible(e("#" + i))
              ? (function (e) {
                  l[e] && "function" == typeof l[e].playVideo && l[e].playVideo();
                })(i)
              : (function (e) {
                  l[e] && "function" == typeof l[e].pauseVideo && l[e].pauseVideo();
                })(i);
        }
        function o(t, i) {
          var n = e("#" + i),
            o = n.attr("id"),
            a = l[o];
          switch (t.data) {
            case -1:
              c[o].attemptedToPlay && (s(n), r(n));
              break;
            case 0:
              a.playVideo();
              break;
            case 1:
              s(n);
              break;
            case 3:
              c[o].attemptedToPlay = !0;
          }
        }
        function a(e) {
          e.closest(m.videoParent).addClass(f.loading);
        }
        function s(e) {
          e.closest(m.videoParent).removeClass(f.loading).addClass(f.loaded);
        }
        function r(e) {
          e.closest(m.videoParent).addClass(f.interactable);
        }
        var d,
          c = [],
          l = [],
          h = { width: 1280, height: 720, playerVars: { autohide: 0, branding: 0, cc_load_policy: 0, controls: 0, fs: 0, iv_load_policy: 3, modestbranding: 1, playsinline: 1, quality: "hd720", rel: 0, showinfo: 0, wmode: "opaque" } },
          u = !1,
          p = { byline: !1, title: !1, portrait: !1, loop: !0 },
          m = { videoParent: ".video-parent-section" },
          f = { loading: "loading", loaded: "loaded", interactable: "video-interactable" };
        return (
          (t.prototype = e.extend({}, t.prototype, {
            initYoutubeVideo: function () {
              (c[this.youtubePlayerId] = {
                id: this.youtubePlayerId,
                videoId: this.youtubeVideoId,
                type: "youtube",
                attemptedToPlay: !1,
                events: {
                  onReady: function (e) {
                    i(e, this.youtubePlayerId);
                  }.bind(this),
                  onStateChange: function (e) {
                    o(e, this.youtubePlayerId);
                  }.bind(this),
                },
              }),
                d ? this.loadYoutubeVideo() : (theme.LibraryLoader.load("youtubeSdk"), e("body").on("youTubeReady" + this.namespace, this.loadYoutubeVideo.bind(this)));
            },
            loadYoutubeVideo: function () {
              var t = e.extend({}, h, c[this.youtubePlayerId]);
              (t.playerVars.controls = 0), (l[this.youtubePlayerId] = new YT.Player(this.youtubePlayerId, t)), (d = !0);
            },
            initVimeoVideo: function () {
              (c[this.vimeoPlayerId] = { divId: this.vimeoPlayerId, id: this.vimeoVideoId, type: "vimeo" }),
                a(e("#" + this.vimeoPlayerId)),
                this.$vimeoTrigger.on(
                  "click",
                  +this.namespace,
                  function (e) {
                    this.requestToPlayVimeoVideo(this.vimeoPlayerId);
                  }.bind(this)
                ),
                u ? this.loadVimeoVideo() : (window.loadVimeo(), e("body").on("vimeoReady" + this.namespace, this.loadVimeoVideo.bind(this)));
            },
            loadVimeoVideo: function () {
              var t = e.extend({}, p, c[this.vimeoPlayerId]);
              ((this.vimeoPlayer[this.vimeoPlayerId] = new Vimeo.Player(c[this.vimeoPlayerId].divId, t)), (u = !0), theme.config.bpSmall) ? s(e("#" + this.vimeoPlayerId)) : this.requestToPlayVimeoVideo(this.vimeoPlayerId);
            },
            requestToPlayVimeoVideo: function (t) {
              return u
                ? void this.playVimeoVideo(t)
                : void e("body").on(
                    "vimeoReady" + this.namespace,
                    function () {
                      this.playVimeoVideo(t);
                    }.bind(this)
                  );
            },
            playVimeoVideo: function (t) {
              this.vimeoPlayer[t].play(), this.vimeoPlayer[t].setVolume(0), s(e("#" + t));
            },
            onUnload: function (t) {
              var i = t.target.id.replace("shopify-section-", "");
              l["YouTubeVideo-" + i].destroy(), e(window).off("scroll" + this.namespace), e("body").off("vimeoReady" + this.namespace);
            },
          })),
          t
        );
      })()),
      (theme.BackgroundImage = (function () {
        function t(t) {
          var n = e(t),
            o = n.attr("data-section-id");
          if (((this.namespace = "." + o), n.length && n.data("parallax"))) {
            var a = n.find(i.parallaxContainer),
              s = { namespace: this.namespace, desktopOnly: !0 };
            theme.parallaxSections[this.namespace] = new theme.Parallax(a, s);
          }
        }
        var i = { parallaxContainer: ".parallax-container" };
        return (
          (t.prototype = e.extend({}, t.prototype, {
            onUnload: function (e) {
              theme.parallaxSections[this.namespace].destroy(), delete theme.parallaxSections[this.namespace];
            },
          })),
          t
        );
      })()),
      (theme.Testimonials = (function () {
        function t(t) {
          var o = (this.$container = e(t)).attr("data-section-id"),
            a = ((this.wrapper = ".testimonials-wrapper"), (this.slider = "#Testimonials-" + o)),
            s = e(a);
          this.sliderActive = !1;
          var r = e.extend({}, n, { slidesToShow: 1, slidesToScroll: 1, adaptiveHeight: !0 });
          (i = s.data("count")) < n.slidesToShow && ((n.slidesToShow = i), (n.slidesToScroll = i)),
            s.on("init", this.a11y.bind(this)),
            theme.config.bpSmall ? this.init(s, r) : this.init(s, n),
            e("body").on(
              "matchSmall",
              function () {
                this.init(s, r);
              }.bind(this)
            ),
            e("body").on(
              "unmatchSmall",
              function () {
                this.init(s, n);
              }.bind(this)
            );
        }
        var i = 0,
          n = { accessibility: !0, arrows: !1, dots: !0, autoplay: !1, touchThreshold: 20, slidesToShow: 3, slidesToScroll: 3 };
        return (
          (t.prototype = e.extend({}, t.prototype, {
            onUnload: function () {
              e(this.slider, this.wrapper).slick("unslick");
            },
            onBlockSelect: function (t) {
              var i = e(".testimonials-slide--" + t.detail.blockId + ":not(.slick-cloned)").data("slick-index");
              e(this.slider, this.wrapper).slick("slickGoTo", i);
            },
            init: function (e, t) {
              this.sliderActive && (e.slick("unslick"), (this.sliderActive = !1)), e.slick(t), (this.sliderActive = !0), AOS && AOS.refresh();
            },
            a11y: function (t, i) {
              var n = i.$list,
                o = e(this.wrapper, this.$container);
              n.removeAttr("aria-live"),
                o.on("focusin", function (e) {
                  o.has(e.target).length && n.attr("aria-live", "polite");
                }),
                o.on("focusout", function (e) {
                  o.has(e.target).length && n.removeAttr("aria-live");
                });
            },
          })),
          t
        );
      })()),
      (theme.NewsletterPopup = (function () {
        function t(t) {
          var i = (this.$container = e(t)),
            n = i.attr("data-section-id");
          if (((this.cookieName = "newsletter-" + n), i.length && "/challenge" !== window.location.pathname)) {
            if (
              ((this.data = { secondsBeforeShow: i.data("delay-seconds"), daysBeforeReappear: i.data("delay-days"), cookie: Cookies.get(this.cookieName), testMode: i.data("test-mode") }),
              (this.modal = new theme.Modals("NewsletterPopup-" + n, "newsletter-popup-modal")),
              (i.find(".errors").length || i.find(".note--success").length) && this.modal.open(),
              i.find(".note--success").length)
            )
              return void this.closePopup(!0);
            e("body").on("modalClose." + i.attr("id"), this.closePopup.bind(this)), (!this.data.cookie || this.data.testMode) && this.initPopupDelay();
          }
        }
        return (
          (t.prototype = e.extend({}, t.prototype, {
            initPopupDelay: function () {
              setTimeout(
                function () {
                  this.modal.open();
                }.bind(this),
                1e3 * this.data.secondsBeforeShow
              );
            },
            closePopup: function (e) {
              if (this.data.testMode) Cookies.remove(this.cookieName, { path: "/" });
              else {
                var t = e ? 200 : this.data.daysBeforeReappear;
                Cookies.set(this.cookieName, "opened", { path: "/", expires: t });
              }
            },
            onLoad: function () {
              this.modal.open();
            },
            onSelect: function () {
              this.modal.open();
            },
            onDeselect: function () {
              this.modal.close();
            },
            onUnload: function () {},
          })),
          t
        );
      })()),
      (theme.FadingImages = (function () {
        function t(t) {
          var i = (this.$container = e(t)),
            n = i.attr("data-section-id");
          if (((this.namespace = ".fading-images-" + n), i.length)) {
            var o = i.find(".fading-images");
            theme.loadImageSection(o),
              (this.data = { isInit: !1, interval: i.data("interval"), block_count: i.data("count"), finish_interval: 1e3, timer_offset: 400, active_image: 1, active_title: 1, removed_compensation: !1 }),
              (this.selectors = { $allTitles: i.find(".fading-images-overlay__titles") }),
              this.checkVisibility(),
              e(window).on("scroll" + this.namespace, e.throttle(100, this.checkVisibility.bind(this)));
          }
        }
        var i = "active-image",
          n = "finished-image",
          o = "active-titles",
          a = "finished-titles",
          s = "compensation";
        return (
          (t.prototype = e.extend({}, t.prototype, {
            checkVisibility: function () {
              return this.data.isInit ? void e(window).off("scroll" + this.namespace) : void (theme.isElementVisible(this.$container) && (this.startImages(), this.startTitles(), (this.data.isInit = !0)));
            },
            nextImage: function () {
              var e = this.$container;
              this.data.removed_compensation || (e.find(".fading-images__item[data-slide-index=" + this.data.active_image + "]").removeClass(s), (this.data.removed_compensation = !0)),
                e
                  .find(".fading-images__item[data-slide-index=" + this.data.active_image + "]")
                  .removeClass(i)
                  .addClass(n);
              var t = this.data.active_image;
              window.setTimeout(function () {
                e.find(".fading-images__item[data-slide-index=" + t + "]").removeClass(n);
              }, this.data.finish_interval),
                this.data.active_image++,
                this.data.active_image > this.data.block_count && (this.data.active_image = 1),
                e.find(".fading-images__item[data-slide-index=" + this.data.active_image + "]").addClass(i);
            },
            nextTitle: function () {
              var e = this.$container,
                t = this.selectors.$allTitles;
              this.selectors.$allTitles.removeClass(o).addClass(a), this.data.active_title++, this.data.active_title > this.data.block_count && (this.data.active_title = 1);
              var i = this.data.active_title;
              window.setTimeout(function () {
                var n = e.find(".fading-images__item[data-slide-index=" + i + "]").attr("data-slide-title1"),
                  s = e.find(".fading-images__item[data-slide-index=" + i + "]").attr("data-slide-title2");
                e.find(".fading-images-overlay__title--1").text(n), e.find(".fading-images-overlay__title--2").text(s), t.removeClass(a).addClass(o);
              }, this.data.finish_interval - 200);
            },
            startImages: function () {
              this.$container
                .find(".fading-images__item[data-slide-index=" + this.data.active_image + "]")
                .addClass(i)
                .addClass(s),
                window.setTimeout(
                  function () {
                    window.setInterval(this.nextImage.bind(this), this.data.interval);
                  }.bind(this),
                  this.data.timer_offset
                );
            },
            startTitles: function () {
              var e = this.$container,
                t = this.selectors.$allTitles,
                i = this.data.active_title;
              window.setTimeout(function () {
                var n = e.find(".fading-images__item[data-slide-index=" + i + "]").attr("data-slide-title1"),
                  a = e.find(".fading-images__item[data-slide-index=" + i + "]").attr("data-slide-title2");
                e.find(".fading-images-overlay__title--1").text(n), e.find(".fading-images-overlay__title--2").text(a), t.addClass(o);
              }, 750),
                window.setInterval(this.nextTitle.bind(this), this.data.interval);
            },
            onLoad: function () {},
            onSelect: function () {},
            onDeselect: function () {},
            onUnload: function () {},
          })),
          t
        );
      })()),
      (theme.Maps = (function () {
        function t(t) {
          (this.$container = e(t)),
            (this.sectionId = this.$container.attr("data-section-id")),
            (this.namespace = ".map-" + this.sectionId),
            (this.$map = this.$container.find(s.map)),
            (this.key = this.$map.data("api-key")),
            this.key && (this.checkVisibility(), e(window).on("scroll" + this.namespace, e.throttle(50, this.checkVisibility.bind(this))));
        }
        var i = 14,
          n = null,
          o = [],
          a = { addressNoResults: theme.strings.addressNoResults, addressQueryLimit: theme.strings.addressQueryLimit, addressError: theme.strings.addressError, authError: theme.strings.authError },
          s = { section: '[data-section-type="map"]', map: "[data-map]", mapOverlay: "[data-map-overlay]" },
          r = "map-section--load-error",
          d = "map-section__error errors text-center";
        return (
          (window.gm_authFailure = function () {
            Shopify.designMode && (e(s.section).addClass(r), e(s.map).remove(), e(s.mapOverlay).after('<div class="' + d + '">' + theme.strings.authError + "</div>"));
          }),
          (t.prototype = e.extend({}, t.prototype, {
            prepMapApi: function () {
              "loaded" === n
                ? this.createMap()
                : (o.push(this),
                  "loading" !== n &&
                    ((n = "loading"),
                    (void 0 === window.google || void 0 === window.google.maps) &&
                      e.getScript("https://maps.googleapis.com/maps/api/js?key=" + this.key).then(function () {
                        (n = "loaded"),
                          e.each(o, function (e, t) {
                            t.createMap();
                          });
                      })));
            },
            createMap: function () {
              var t = this.$map;
              return (function (t) {
                var i = e.Deferred(),
                  n = new google.maps.Geocoder(),
                  o = t.data("address-setting");
                return (
                  n.geocode({ address: o }, function (e, t) {
                    t !== google.maps.GeocoderStatus.OK && i.reject(t), i.resolve(e);
                  }),
                  i
                );
              })(t)
                .then(
                  function (n) {
                    var o = { zoom: i, backgroundColor: "none", center: n[0].geometry.location, draggable: !1, clickableIcons: !1, scrollwheel: !1, disableDoubleClickZoom: !0, disableDefaultUI: !0 },
                      a = (this.map = new google.maps.Map(t[0], o)),
                      s = (this.center = a.getCenter());
                    new google.maps.Marker({ map: a, position: a.getCenter() }),
                      google.maps.event.addDomListener(
                        window,
                        "resize",
                        e.debounce(250, function () {
                          google.maps.event.trigger(a, "resize"), a.setCenter(s), t.removeAttr("style");
                        })
                      );
                  }.bind(this)
                )
                .fail(function () {
                  var e;
                  switch (status) {
                    case "ZERO_RESULTS":
                      e = a.addressNoResults;
                      break;
                    case "OVER_QUERY_LIMIT":
                      e = a.addressQueryLimit;
                      break;
                    case "REQUEST_DENIED":
                      e = a.authError;
                      break;
                    default:
                      e = a.addressError;
                  }
                  Shopify.designMode &&
                    t
                      .parent()
                      .addClass(r)
                      .html('<div class="' + d + '">' + e + "</div>");
                });
            },
            checkVisibility: function () {
              theme.isElementVisible(this.$container, 600) && (this.prepMapApi(), e(window).off(this.namespace));
            },
            onUnload: function () {
              0 !== this.$map.length && google.maps.event.clearListeners(this.map, "resize");
            },
          })),
          t
        );
      })()),
      (theme.Blog = (function () {
        function t(e) {
          this.tagFilters();
        }
        return (
          (t.prototype = e.extend({}, t.prototype, {
            tagFilters: function () {
              var t = e("#BlogTagFilter");
              t.length &&
                t.on("change", function () {
                  location.href = e(this).val();
                });
            },
            onUnload: function () {},
          })),
          t
        );
      })()),
      (theme.Photoswipe = (function () {
        function t(t, i) {
          (this.$container = e(t)),
            (this.sectionId = i),
            (this.namespace = ".photoswipe-" + this.sectionId),
            this.gallery,
            this.$images,
            (this.inSlideshow = !1),
            "false" !== this.$container.attr("data-zoom") && ("true" === this.$container.attr("data-has-slideshow") && (this.inSlideshow = !0), this.init());
        }
        var i = ".js-photoswipe__zoom",
          n = ".photoswipe__image",
          o = ".slick-active .photoswipe__image";
        return (
          (t.prototype = e.extend({}, t.prototype, {
            init: function () {
              var t = this.$container.find(i);
              this.$images = this.$container.find(n);
              var a = [];
              t.on(
                "click" + this.namespace,
                function (t) {
                  if (((a = this.getImageData()), this.inSlideshow)) var i = this.$container.find(o).data("index");
                  else i = e(t.currentTarget).data("index");
                  this.initGallery(a, i);
                }.bind(this)
              );
            },
            getImageData: function () {
              var t = [];
              return (
                this.$images.each(function () {
                  var i = { msrc: e(this).prop("currentSrc") || e(this).prop("src"), src: e(this).data("photoswipe-src"), w: e(this).data("photoswipe-width"), h: e(this).data("photoswipe-height"), el: e(this)[0], initialZoomLevel: 0.5 };
                  t.push(i);
                }),
                t
              );
            },
            initGallery: function (e, t) {
              var i = document.querySelectorAll(".pswp")[0],
                n = {
                  allowPanToNext: !1,
                  captionEl: !1,
                  closeOnScroll: !1,
                  counterEl: !1,
                  history: !1,
                  index: t - 1,
                  pinchToClose: !1,
                  preloaderEl: !1,
                  scaleMode: "zoom",
                  shareEl: !1,
                  tapToToggleControls: !1,
                  getThumbBoundsFn: function (t) {
                    var i = window.pageYOffset || document.documentElement.scrollTop,
                      n = e[t].el.getBoundingClientRect();
                    return { x: n.left, y: n.top + i, w: n.width };
                  },
                };
              (this.gallery = new PhotoSwipe(i, PhotoSwipeUI_Default, e, n)), this.gallery.init(), this.gallery.listen("afterChange", this.afterChange.bind(this));
            },
            afterChange: function () {
              if (this.inSlideshow) {
                var t = e("#ProductPhotos-" + this.sectionId);
                if (t.hasClass("slick-initialized")) {
                  var i = this.gallery.getCurrentIndex();
                  t.slick("slickGoTo", i);
                }
              }
            },
          })),
          t
        );
      })()),
      (theme.bp = {}),
      (theme.bp.smallUp = 590),
      (theme.bp.small = theme.bp.smallUp - 1),
      (theme.config = {
        bpSmall: !1,
        hasSessionStorage: !0,
        mediaQuerySmall: "screen and (max-width: " + theme.bp.small + "px)",
        mediaQuerySmallUp: "screen and (min-width: " + theme.bp.smallUp + "px)",
        youTubeReady: !1,
        vimeoReady: !1,
        vimeoLoading: !1,
        isTouch: !!("ontouchstart" in window || (window.DocumentTouch && window.document instanceof DocumentTouch) || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints),
        isIpad: /ipad/.test(window.navigator.userAgent.toLowerCase()) || ("MacIntel" === window.navigator.platform && window.navigator.maxTouchPoints > 1),
      }),
      theme.config.isIpad && (document.documentElement.className += " js-ipad"),
      (window.onYouTubeIframeAPIReady = function () {
        (theme.config.youTubeReady = !0), e("body").trigger("youTubeReady");
      }),
      (window.loadVimeo = function () {
        if (!theme.config.vimeoLoading && !theme.config.vimeoReady) {
          theme.config.vimeoLoading = !0;
          var t = document.createElement("script");
          t.src = "https://player.vimeo.com/api/player.js";
          var i = document.getElementsByTagName("script")[0];
          i.parentNode.insertBefore(t, i),
            (function () {
              var t,
                i,
                n = e.Deferred();
              return (
                (t = setInterval(function () {
                  Vimeo && (clearInterval(t), clearTimeout(i), n.resolve());
                }, 500)),
                (i = setTimeout(function () {
                  clearInterval(t), n.reject();
                }, 4e3)),
                n
              );
            })()
              .then(function () {
                (theme.config.vimeoReady = !0), (theme.config.vimeoLoading = !1), e("body").trigger("vimeoReady");
              })
              .fail(function () {});
        }
      }),
      (theme.init = function () {
        theme.setGlobals(),
          theme.pageTransitions(),
          theme.initQuickShop(),
          theme.settings.predictiveSearch && theme.predictiveSearch.init(),
          theme.videoModal(),
          theme.articleImages.init(),
          theme.customerTemplates.init(),
          theme.collapsibles.init(),
          theme.rte.init(),
          AOS.init({ easing: "ease-out-quad", once: !0, offset: 60, disableMutationObserver: !0 }),
          e(document.documentElement).on("keyup.tab", function (t) {
            9 === t.keyCode && (e(document.documentElement).addClass("tab-outline"), e(document.documentElement).off("keyup.tab"));
          });
      }),
      (theme.setGlobals = function () {
        (theme.config.hasSessionStorage = theme.isSessionStorageSupported()),
          theme.config.isTouch && e("body").addClass("supports-touch"),
          enquire.register(theme.config.mediaQuerySmall, {
            match: function () {
              (theme.config.bpSmall = !0), e("body").trigger("matchSmall");
            },
            unmatch: function () {
              (theme.config.bpSmall = !1), e("body").trigger("unmatchSmall");
            },
          });
      }),
      (theme.loadImageSection = function (e) {
        function t() {
          e.removeClass("loading loading--delayed").addClass("loaded");
        }
        function i() {
          return e.find(".lazyloaded").length;
        }
        if (e.find("svg").length) t();
        else if (i() > 0) t();
        else
          var n = setInterval(function () {
            i() > 0 && (clearInterval(n), t());
          }, 80);
      }),
      (theme.isSessionStorageSupported = function () {
        if (window.self !== window.top) return !1;
        var e = "test",
          t = window.sessionStorage;
        try {
          return t.setItem(e, "1"), t.removeItem(e), !0;
        } catch (e) {
          return !1;
        }
      }),
      (theme.isElementVisible = function (e, t) {
        var i = e[0].getBoundingClientRect(),
          n = window.innerHeight || document.documentElement.clientHeight;
        return (t = t || 0), i.bottom >= 0 && i.right >= 0 && i.top <= n + t && i.left <= (window.innerWidth || document.documentElement.clientWidth);
      }),
      (theme.pageTransitions = function () {
        1 == e("body").data("transitions") &&
          (navigator.userAgent.match(/Version\/[\d\.]+.*Safari/) &&
            e("a").on("click", function () {
              window.setTimeout(function () {
                e("body").removeClass("unloading");
              }, 1200);
            }),
          e('a[href^="mailto:"], a[href^="#"], a[target="_blank"], a[href*="youtube.com/watch"], a[href*="youtu.be/"]').each(function () {
            e(this).addClass("js-no-transition");
          }),
          e("a:not(.js-no-transition)").bind("click", function (t) {
            if (t.metaKey) return !0;
            t.preventDefault(), e("body").addClass("unloading");
            var i = e(this).attr("href");
            window.setTimeout(function () {
              location.href = i;
            }, 50);
          }),
          e("a.mobile-nav__link").bind("click", function () {
            theme.NavDrawer.close();
          }));
      }),
      (theme.reinitProductGridItem = function (e) {
        AOS && AOS.refreshHard(), theme.initQuickShop(!0), window.SPR && (SPR.initDomEls(), SPR.loadBadges()), sections.register("product-template", theme.Product, e), theme.collapsibles.init();
      }),
      (window.onpageshow = function (t) {
        t.persisted && e("body").removeClass("unloading");
      }),
      e(document).ready(function () {
        theme.init(),
          (window.sections = new theme.Sections()),
          sections.register("header-section", theme.HeaderSection),
          sections.register("slideshow-section", theme.SlideshowSection),
          sections.register("video-section", theme.VideoSection),
          sections.register("product", theme.Product),
          sections.register("product-recommendations", theme.Recommendations),
          sections.register("product-template", theme.Product),
          sections.register("collection-template", theme.Collection),
          sections.register("featured-content-section", theme.FeaturedContentSection),
          sections.register("collection-switcher", theme.CollectionSwitcher),
          sections.register("testimonials", theme.Testimonials),
          sections.register("newsletter-popup", theme.NewsletterPopup),
          sections.register("fading-images", theme.FadingImages),
          sections.register("background-image", theme.BackgroundImage),
          sections.register("map", theme.Maps),
          sections.register("blog", theme.Blog),
          sections.register("photoswipe", theme.Photoswipe),
          sections.register("footer-section", theme.FooterSection);
        const e = document.querySelectorAll(".product-single__form");
        e.length &&
          e.forEach((e) => {
            if (!e) return;
            const t = Object.fromEntries(new FormData(e));
            e.addEventListener("submit", (e) =>
              ((e, t) => {
                e.preventDefault(),
                  theme.cart.addItemFromForm(t).then(function (e) {
                    $("body").trigger("added.ajaxProduct", $(document));
                  });
              })(e, t)
            );
          });
      });
  })(theme.jQuery);


